/*!
 * imagesLoaded PACKAGED v3.1.8 * JavaScript is all like "You images are done yet or what?" * MIT License
 */
(function(){function e(){}function t(e,t){for(var n=e.length;n--;)if(e[n].listener===t)return n;return-1}function n(e){return function(){return this[e].apply(this,arguments)}}var i=e.prototype,r=this,o=r.EventEmitter;i.getListeners=function(e){var t,n,i=this._getEvents();if("object"==typeof e){t={};for(n in i)i.hasOwnProperty(n)&&e.test(n)&&(t[n]=i[n])}else t=i[e]||(i[e]=[]);return t},i.flattenListeners=function(e){var t,n=[];for(t=0;e.length>t;t+=1)n.push(e[t].listener);return n},i.getListenersAsObject=function(e){var t,n=this.getListeners(e);return n instanceof Array&&(t={},t[e]=n),t||n},i.addListener=function(e,n){var i,r=this.getListenersAsObject(e),o="object"==typeof n;for(i in r)r.hasOwnProperty(i)&&-1===t(r[i],n)&&r[i].push(o?n:{listener:n,once:!1});return this},i.on=n("addListener"),i.addOnceListener=function(e,t){return this.addListener(e,{listener:t,once:!0})},i.once=n("addOnceListener"),i.defineEvent=function(e){return this.getListeners(e),this},i.defineEvents=function(e){for(var t=0;e.length>t;t+=1)this.defineEvent(e[t]);return this},i.removeListener=function(e,n){var i,r,o=this.getListenersAsObject(e);for(r in o)o.hasOwnProperty(r)&&(i=t(o[r],n),-1!==i&&o[r].splice(i,1));return this},i.off=n("removeListener"),i.addListeners=function(e,t){return this.manipulateListeners(!1,e,t)},i.removeListeners=function(e,t){return this.manipulateListeners(!0,e,t)},i.manipulateListeners=function(e,t,n){var i,r,o=e?this.removeListener:this.addListener,s=e?this.removeListeners:this.addListeners;if("object"!=typeof t||t instanceof RegExp)for(i=n.length;i--;)o.call(this,t,n[i]);else for(i in t)t.hasOwnProperty(i)&&(r=t[i])&&("function"==typeof r?o.call(this,i,r):s.call(this,i,r));return this},i.removeEvent=function(e){var t,n=typeof e,i=this._getEvents();if("string"===n)delete i[e];else if("object"===n)for(t in i)i.hasOwnProperty(t)&&e.test(t)&&delete i[t];else delete this._events;return this},i.removeAllListeners=n("removeEvent"),i.emitEvent=function(e,t){var n,i,r,o,s=this.getListenersAsObject(e);for(r in s)if(s.hasOwnProperty(r))for(i=s[r].length;i--;)n=s[r][i],n.once===!0&&this.removeListener(e,n.listener),o=n.listener.apply(this,t||[]),o===this._getOnceReturnValue()&&this.removeListener(e,n.listener);return this},i.trigger=n("emitEvent"),i.emit=function(e){var t=Array.prototype.slice.call(arguments,1);return this.emitEvent(e,t)},i.setOnceReturnValue=function(e){return this._onceReturnValue=e,this},i._getOnceReturnValue=function(){return this.hasOwnProperty("_onceReturnValue")?this._onceReturnValue:!0},i._getEvents=function(){return this._events||(this._events={})},e.noConflict=function(){return r.EventEmitter=o,e},"function"==typeof define&&define.amd?define("eventEmitter/EventEmitter",[],function(){return e}):"object"==typeof module&&module.exports?module.exports=e:this.EventEmitter=e}).call(this),function(e){function t(t){var n=e.event;return n.target=n.target||n.srcElement||t,n}var n=document.documentElement,i=function(){};n.addEventListener?i=function(e,t,n){e.addEventListener(t,n,!1)}:n.attachEvent&&(i=function(e,n,i){e[n+i]=i.handleEvent?function(){var n=t(e);i.handleEvent.call(i,n)}:function(){var n=t(e);i.call(e,n)},e.attachEvent("on"+n,e[n+i])});var r=function(){};n.removeEventListener?r=function(e,t,n){e.removeEventListener(t,n,!1)}:n.detachEvent&&(r=function(e,t,n){e.detachEvent("on"+t,e[t+n]);try{delete e[t+n]}catch(i){e[t+n]=void 0}});var o={bind:i,unbind:r};"function"==typeof define&&define.amd?define("eventie/eventie",o):e.eventie=o}(this),function(e,t){"function"==typeof define&&define.amd?define(["eventEmitter/EventEmitter","eventie/eventie"],function(n,i){return t(e,n,i)}):"object"==typeof exports?module.exports=t(e,require("wolfy87-eventemitter"),require("eventie")):e.imagesLoaded=t(e,e.EventEmitter,e.eventie)}(window,function(e,t,n){function i(e,t){for(var n in t)e[n]=t[n];return e}function r(e){return"[object Array]"===d.call(e)}function o(e){var t=[];if(r(e))t=e;else if("number"==typeof e.length)for(var n=0,i=e.length;i>n;n++)t.push(e[n]);else t.push(e);return t}function s(e,t,n){if(!(this instanceof s))return new s(e,t);"string"==typeof e&&(e=document.querySelectorAll(e)),this.elements=o(e),this.options=i({},this.options),"function"==typeof t?n=t:i(this.options,t),n&&this.on("always",n),this.getImages(),a&&(this.jqDeferred=new a.Deferred);var r=this;setTimeout(function(){r.check()})}function f(e){this.img=e}function c(e){this.src=e,v[e]=this}var a=e.jQuery,u=e.console,h=u!==void 0,d=Object.prototype.toString;s.prototype=new t,s.prototype.options={},s.prototype.getImages=function(){this.images=[];for(var e=0,t=this.elements.length;t>e;e++){var n=this.elements[e];"IMG"===n.nodeName&&this.addImage(n);var i=n.nodeType;if(i&&(1===i||9===i||11===i))for(var r=n.querySelectorAll("img"),o=0,s=r.length;s>o;o++){var f=r[o];this.addImage(f)}}},s.prototype.addImage=function(e){var t=new f(e);this.images.push(t)},s.prototype.check=function(){function e(e,r){return t.options.debug&&h&&u.log("confirm",e,r),t.progress(e),n++,n===i&&t.complete(),!0}var t=this,n=0,i=this.images.length;if(this.hasAnyBroken=!1,!i)return this.complete(),void 0;for(var r=0;i>r;r++){var o=this.images[r];o.on("confirm",e),o.check()}},s.prototype.progress=function(e){this.hasAnyBroken=this.hasAnyBroken||!e.isLoaded;var t=this;setTimeout(function(){t.emit("progress",t,e),t.jqDeferred&&t.jqDeferred.notify&&t.jqDeferred.notify(t,e)})},s.prototype.complete=function(){var e=this.hasAnyBroken?"fail":"done";this.isComplete=!0;var t=this;setTimeout(function(){if(t.emit(e,t),t.emit("always",t),t.jqDeferred){var n=t.hasAnyBroken?"reject":"resolve";t.jqDeferred[n](t)}})},a&&(a.fn.imagesLoaded=function(e,t){var n=new s(this,e,t);return n.jqDeferred.promise(a(this))}),f.prototype=new t,f.prototype.check=function(){var e=v[this.img.src]||new c(this.img.src);if(e.isConfirmed)return this.confirm(e.isLoaded,"cached was confirmed"),void 0;if(this.img.complete&&void 0!==this.img.naturalWidth)return this.confirm(0!==this.img.naturalWidth,"naturalWidth"),void 0;var t=this;e.on("confirm",function(e,n){return t.confirm(e.isLoaded,n),!0}),e.check()},f.prototype.confirm=function(e,t){this.isLoaded=e,this.emit("confirm",this,t)};var v={};return c.prototype=new t,c.prototype.check=function(){if(!this.isChecked){var e=new Image;n.bind(e,"load",this),n.bind(e,"error",this),e.src=this.src,this.isChecked=!0}},c.prototype.handleEvent=function(e){var t="on"+e.type;this[t]&&this[t](e)},c.prototype.onload=function(e){this.confirm(!0,"onload"),this.unbindProxyEvents(e)},c.prototype.onerror=function(e){this.confirm(!1,"onerror"),this.unbindProxyEvents(e)},c.prototype.confirm=function(e,t){this.isConfirmed=!0,this.isLoaded=e,this.emit("confirm",this,t)},c.prototype.unbindProxyEvents=function(e){n.unbind(e.target,"load",this),n.unbind(e.target,"error",this)},s});

/**
 * jQuery serializeObject * @copyright 2014, macek <paulmacek@gmail.com> * @link https://github.com/macek/jquery-serialize-object * @license BSD * @version 2.5.0
 */
!function(e,i){if("function"==typeof define&&define.amd)define(["exports","jquery"],function(e,r){return i(e,r)});else if("undefined"!=typeof exports){var r=require("jquery");i(exports,r)}else i(e,e.jQuery||e.Zepto||e.ender||e.$)}(this,function(e,i){function r(e,r){function n(e,i,r){return e[i]=r,e}function a(e,i){for(var r,a=e.match(t.key);void 0!==(r=a.pop());)if(t.push.test(r)){var u=s(e.replace(/\[\]$/,""));i=n([],u,i)}else t.fixed.test(r)?i=n([],r,i):t.named.test(r)&&(i=n({},r,i));return i}function s(e){return void 0===h[e]&&(h[e]=0),h[e]++}function u(e){switch(i('[name="'+e.name+'"]',r).attr("type")){case"checkbox":return"on"===e.value?!0:e.value;default:return e.value}}function f(i){if(!t.validate.test(i.name))return this;var r=a(i.name,u(i));return l=e.extend(!0,l,r),this}function d(i){if(!e.isArray(i))throw new Error("formSerializer.addPairs expects an Array");for(var r=0,t=i.length;t>r;r++)this.addPair(i[r]);return this}function o(){return l}function c(){return JSON.stringify(o())}var l={},h={};this.addPair=f,this.addPairs=d,this.serialize=o,this.serializeJSON=c}var t={validate:/^[a-z_][a-z0-9_]*(?:\[(?:\d*|[a-z0-9_]+)\])*$/i,key:/[a-z0-9_]+|(?=\[\])/gi,push:/^$/,fixed:/^\d+$/,named:/^[a-z0-9_]+$/i};return r.patterns=t,r.serializeObject=function(){return new r(i,this).addPairs(this.serializeArray()).serialize()},r.serializeJSON=function(){return new r(i,this).addPairs(this.serializeArray()).serializeJSON()},"undefined"!=typeof i.fn&&(i.fn.serializeObject=r.serializeObject,i.fn.serializeJSON=r.serializeJSON),e.FormSerializer=r,r});

/**
 * SimpleBar.js - v4.1.0 * Scrollbars, simpler. * https://grsmto.github.io/simplebar/ * Made by Adrien Denat from a fork by Jonathan Nicol * Under MIT License
 */
!function(t,e){"object"==typeof exports&&"undefined"!=typeof module?module.exports=e():"function"==typeof define&&define.amd?define(e):(t=t||self).SimpleBar=e()}(this,function(){"use strict";var t=function(t){if("function"!=typeof t)throw TypeError(String(t)+" is not a function");return t},e=function(t){try{return!!t()}catch(t){return!0}},i={}.toString,r=function(t){return i.call(t).slice(8,-1)},n="".split,s=e(function(){return!Object("z").propertyIsEnumerable(0)})?function(t){return"String"==r(t)?n.call(t,""):Object(t)}:Object,o=function(t){if(null==t)throw TypeError("Can't call method on "+t);return t},a=function(t){return Object(o(t))},l=Math.ceil,c=Math.floor,u=function(t){return isNaN(t=+t)?0:(t>0?c:l)(t)},h=Math.min,f=function(t){return t>0?h(u(t),9007199254740991):0},d=function(t){return"object"==typeof t?null!==t:"function"==typeof t},p=Array.isArray||function(t){return"Array"==r(t)},v="undefined"!=typeof globalThis?globalThis:"undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{};function g(t,e){return t(e={exports:{}},e.exports),e.exports}var b,m,y,x,E="object"==typeof window&&window&&window.Math==Math?window:"object"==typeof self&&self&&self.Math==Math?self:Function("return this")(),w=!e(function(){return 7!=Object.defineProperty({},"a",{get:function(){return 7}}).a}),O=E.document,_=d(O)&&d(O.createElement),S=!w&&!e(function(){return 7!=Object.defineProperty((t="div",_?O.createElement(t):{}),"a",{get:function(){return 7}}).a;var t}),L=function(t){if(!d(t))throw TypeError(String(t)+" is not an object");return t},A=function(t,e){if(!d(t))return t;var i,r;if(e&&"function"==typeof(i=t.toString)&&!d(r=i.call(t)))return r;if("function"==typeof(i=t.valueOf)&&!d(r=i.call(t)))return r;if(!e&&"function"==typeof(i=t.toString)&&!d(r=i.call(t)))return r;throw TypeError("Can't convert object to primitive value")},k=Object.defineProperty,M={f:w?k:function(t,e,i){if(L(t),e=A(e,!0),L(i),S)try{return k(t,e,i)}catch(t){}if("get"in i||"set"in i)throw TypeError("Accessors not supported");return"value"in i&&(t[e]=i.value),t}},W=function(t,e){return{enumerable:!(1&t),configurable:!(2&t),writable:!(4&t),value:e}},T=w?function(t,e,i){return M.f(t,e,W(1,i))}:function(t,e,i){return t[e]=i,t},R=function(t,e){try{T(E,t,e)}catch(i){E[t]=e}return e},j=g(function(t){var e=E["__core-js_shared__"]||R("__core-js_shared__",{});(t.exports=function(t,i){return e[t]||(e[t]=void 0!==i?i:{})})("versions",[]).push({version:"3.0.1",mode:"global",copyright:"© 2019 Denis Pushkarev (zloirock.ru)"})}),C=0,N=Math.random(),z=function(t){return"Symbol(".concat(void 0===t?"":t,")_",(++C+N).toString(36))},D=!e(function(){return!String(Symbol())}),V=j("wks"),B=E.Symbol,I=function(t){return V[t]||(V[t]=D&&B[t]||(D?B:z)("Symbol."+t))},P=I("species"),H=function(t,e){var i;return p(t)&&("function"!=typeof(i=t.constructor)||i!==Array&&!p(i.prototype)?d(i)&&null===(i=i[P])&&(i=void 0):i=void 0),new(void 0===i?Array:i)(0===e?0:e)},q=function(e,i){var r=1==e,n=2==e,o=3==e,l=4==e,c=6==e,u=5==e||c,h=i||H;return function(i,d,p){for(var v,g,b=a(i),m=s(b),y=function(e,i,r){if(t(e),void 0===i)return e;switch(r){case 0:return function(){return e.call(i)};case 1:return function(t){return e.call(i,t)};case 2:return function(t,r){return e.call(i,t,r)};case 3:return function(t,r,n){return e.call(i,t,r,n)}}return function(){return e.apply(i,arguments)}}(d,p,3),x=f(m.length),E=0,w=r?h(i,x):n?h(i,0):void 0;x>E;E++)if((u||E in m)&&(g=y(v=m[E],E,b),e))if(r)w[E]=g;else if(g)switch(e){case 3:return!0;case 5:return v;case 6:return E;case 2:w.push(v)}else if(l)return!1;return c?-1:o||l?l:w}},F=I("species"),$={}.propertyIsEnumerable,Y=Object.getOwnPropertyDescriptor,X={f:Y&&!$.call({1:2},1)?function(t){var e=Y(this,t);return!!e&&e.enumerable}:$},G=function(t){return s(o(t))},K={}.hasOwnProperty,U=function(t,e){return K.call(t,e)},J=Object.getOwnPropertyDescriptor,Q={f:w?J:function(t,e){if(t=G(t),e=A(e,!0),S)try{return J(t,e)}catch(t){}if(U(t,e))return W(!X.f.call(t,e),t[e])}},Z=j("native-function-to-string",Function.toString),tt=E.WeakMap,et="function"==typeof tt&&/native code/.test(Z.call(tt)),it=j("keys"),rt={},nt=E.WeakMap;if(et){var st=new nt,ot=st.get,at=st.has,lt=st.set;b=function(t,e){return lt.call(st,t,e),e},m=function(t){return ot.call(st,t)||{}},y=function(t){return at.call(st,t)}}else{var ct=it[x="state"]||(it[x]=z(x));rt[ct]=!0,b=function(t,e){return T(t,ct,e),e},m=function(t){return U(t,ct)?t[ct]:{}},y=function(t){return U(t,ct)}}var ut,ht,ft={set:b,get:m,has:y,enforce:function(t){return y(t)?m(t):b(t,{})},getterFor:function(t){return function(e){var i;if(!d(e)||(i=m(e)).type!==t)throw TypeError("Incompatible receiver, "+t+" required");return i}}},dt=g(function(t){var e=ft.get,i=ft.enforce,r=String(Z).split("toString");j("inspectSource",function(t){return Z.call(t)}),(t.exports=function(t,e,n,s){var o=!!s&&!!s.unsafe,a=!!s&&!!s.enumerable,l=!!s&&!!s.noTargetGet;"function"==typeof n&&("string"!=typeof e||U(n,"name")||T(n,"name",e),i(n).source=r.join("string"==typeof e?e:"")),t!==E?(o?!l&&t[e]&&(a=!0):delete t[e],a?t[e]=n:T(t,e,n)):a?t[e]=n:R(e,n)})(Function.prototype,"toString",function(){return"function"==typeof this&&e(this).source||Z.call(this)})}),pt=Math.max,vt=Math.min,gt=(ut=!1,function(t,e,i){var r,n=G(t),s=f(n.length),o=function(t,e){var i=u(t);return i<0?pt(i+e,0):vt(i,e)}(i,s);if(ut&&e!=e){for(;s>o;)if((r=n[o++])!=r)return!0}else for(;s>o;o++)if((ut||o in n)&&n[o]===e)return ut||o||0;return!ut&&-1}),bt=function(t,e){var i,r=G(t),n=0,s=[];for(i in r)!U(rt,i)&&U(r,i)&&s.push(i);for(;e.length>n;)U(r,i=e[n++])&&(~gt(s,i)||s.push(i));return s},mt=["constructor","hasOwnProperty","isPrototypeOf","propertyIsEnumerable","toLocaleString","toString","valueOf"],yt=mt.concat("length","prototype"),xt={f:Object.getOwnPropertyNames||function(t){return bt(t,yt)}},Et={f:Object.getOwnPropertySymbols},wt=E.Reflect,Ot=wt&&wt.ownKeys||function(t){var e=xt.f(L(t)),i=Et.f;return i?e.concat(i(t)):e},_t=function(t,e){for(var i=Ot(e),r=M.f,n=Q.f,s=0;s<i.length;s++){var o=i[s];U(t,o)||r(t,o,n(e,o))}},St=/#|\.prototype\./,Lt=function(t,i){var r=kt[At(t)];return r==Wt||r!=Mt&&("function"==typeof i?e(i):!!i)},At=Lt.normalize=function(t){return String(t).replace(St,".").toLowerCase()},kt=Lt.data={},Mt=Lt.NATIVE="N",Wt=Lt.POLYFILL="P",Tt=Lt,Rt=Q.f,jt=function(t,e){var i,r,n,s,o,a=t.target,l=t.global,c=t.stat;if(i=l?E:c?E[a]||R(a,{}):(E[a]||{}).prototype)for(r in e){if(s=e[r],n=t.noTargetGet?(o=Rt(i,r))&&o.value:i[r],!Tt(l?r:a+(c?".":"#")+r,t.forced)&&void 0!==n){if(typeof s==typeof n)continue;_t(s,n)}(t.sham||n&&n.sham)&&T(s,"sham",!0),dt(i,r,s,t)}},Ct=q(2);jt({target:"Array",proto:!0,forced:!(ht="filter",!e(function(){var t=[];return(t.constructor={})[F]=function(){return{foo:1}},1!==t[ht](Boolean).foo}))},{filter:function(t){return Ct(this,t,arguments[1])}});var Nt=function(t,i){var r=[][t];return!r||!e(function(){r.call(null,i||function(){throw 1},1)})},zt=[].forEach,Dt=q(0),Vt=Nt("forEach")?function(t){return Dt(this,t,arguments[1])}:zt;jt({target:"Array",proto:!0,forced:[].forEach!=Vt},{forEach:Vt});jt({target:"Array",proto:!0,forced:Nt("reduce")},{reduce:function(e){return function(e,i,r,n,o){t(i);var l=a(e),c=s(l),u=f(l.length),h=o?u-1:0,d=o?-1:1;if(r<2)for(;;){if(h in c){n=c[h],h+=d;break}if(h+=d,o?h<0:u<=h)throw TypeError("Reduce of empty array with no initial value")}for(;o?h>=0:u>h;h+=d)h in c&&(n=i(n,c[h],h,l));return n}(this,e,arguments.length,arguments[1],!1)}});var Bt=M.f,It=Function.prototype,Pt=It.toString,Ht=/^\s*function ([^ (]*)/;!w||"name"in It||Bt(It,"name",{configurable:!0,get:function(){try{return Pt.call(this).match(Ht)[1]}catch(t){return""}}});var qt=Object.keys||function(t){return bt(t,mt)},Ft=Object.assign,$t=!Ft||e(function(){var t={},e={},i=Symbol();return t[i]=7,"abcdefghijklmnopqrst".split("").forEach(function(t){e[t]=t}),7!=Ft({},t)[i]||"abcdefghijklmnopqrst"!=qt(Ft({},e)).join("")})?function(t,e){for(var i=a(t),r=arguments.length,n=1,o=Et.f,l=X.f;r>n;)for(var c,u=s(arguments[n++]),h=o?qt(u).concat(o(u)):qt(u),f=h.length,d=0;f>d;)l.call(u,c=h[d++])&&(i[c]=u[c]);return i}:Ft;jt({target:"Object",stat:!0,forced:Object.assign!==$t},{assign:$t});var Yt="\t\n\v\f\r                　\u2028\u2029\ufeff",Xt="["+Yt+"]",Gt=RegExp("^"+Xt+Xt+"*"),Kt=RegExp(Xt+Xt+"*$"),Ut=E.parseInt,Jt=/^[-+]?0[xX]/,Qt=8!==Ut(Yt+"08")||22!==Ut(Yt+"0x16")?function(t,e){var i=function(t,e){return t=String(o(t)),1&e&&(t=t.replace(Gt,"")),2&e&&(t=t.replace(Kt,"")),t}(String(t),3);return Ut(i,e>>>0||(Jt.test(i)?16:10))}:Ut;jt({global:!0,forced:parseInt!=Qt},{parseInt:Qt});var Zt,te,ee=RegExp.prototype.exec,ie=String.prototype.replace,re=ee,ne=(Zt=/a/,te=/b*/g,ee.call(Zt,"a"),ee.call(te,"a"),0!==Zt.lastIndex||0!==te.lastIndex),se=void 0!==/()??/.exec("")[1];(ne||se)&&(re=function(t){var e,i,r,n,s=this;return se&&(i=new RegExp("^"+s.source+"$(?!\\s)",function(){var t=L(this),e="";return t.global&&(e+="g"),t.ignoreCase&&(e+="i"),t.multiline&&(e+="m"),t.unicode&&(e+="u"),t.sticky&&(e+="y"),e}.call(s))),ne&&(e=s.lastIndex),r=ee.call(s,t),ne&&r&&(s.lastIndex=s.global?r.index+r[0].length:e),se&&r&&r.length>1&&ie.call(r[0],i,function(){for(n=1;n<arguments.length-2;n++)void 0===arguments[n]&&(r[n]=void 0)}),r});var oe=re;jt({target:"RegExp",proto:!0,forced:/./.exec!==oe},{exec:oe});var ae=function(t,e,i){return e+(i?function(t,e,i){var r,n,s=String(o(t)),a=u(e),l=s.length;return a<0||a>=l?i?"":void 0:(r=s.charCodeAt(a))<55296||r>56319||a+1===l||(n=s.charCodeAt(a+1))<56320||n>57343?i?s.charAt(a):r:i?s.slice(a,a+2):n-56320+(r-55296<<10)+65536}(t,e,!0).length:1)},le=function(t,e){var i=t.exec;if("function"==typeof i){var n=i.call(t,e);if("object"!=typeof n)throw TypeError("RegExp exec method returned something other than an Object or null");return n}if("RegExp"!==r(t))throw TypeError("RegExp#exec called on incompatible receiver");return oe.call(t,e)},ce=I("species"),ue=!e(function(){var t=/./;return t.exec=function(){var t=[];return t.groups={a:"7"},t},"7"!=="".replace(t,"$<a>")}),he=!e(function(){var t=/(?:)/,e=t.exec;t.exec=function(){return e.apply(this,arguments)};var i="ab".split(t);return 2!==i.length||"a"!==i[0]||"b"!==i[1]}),fe=function(t,i,r,n){var s=I(t),o=!e(function(){var e={};return e[s]=function(){return 7},7!=""[t](e)}),a=o&&!e(function(){var e=!1,i=/a/;return i.exec=function(){return e=!0,null},"split"===t&&(i.constructor={},i.constructor[ce]=function(){return i}),i[s](""),!e});if(!o||!a||"replace"===t&&!ue||"split"===t&&!he){var l=/./[s],c=r(s,""[t],function(t,e,i,r,n){return e.exec===oe?o&&!n?{done:!0,value:l.call(e,i,r)}:{done:!0,value:t.call(i,e,r)}:{done:!1}}),u=c[0],h=c[1];dt(String.prototype,t,u),dt(RegExp.prototype,s,2==i?function(t,e){return h.call(t,this,e)}:function(t){return h.call(t,this)}),n&&T(RegExp.prototype[s],"sham",!0)}};fe("match",1,function(t,e,i){return[function(e){var i=o(this),r=null==e?void 0:e[t];return void 0!==r?r.call(e,i):new RegExp(e)[t](String(i))},function(t){var r=i(e,t,this);if(r.done)return r.value;var n=L(t),s=String(this);if(!n.global)return le(n,s);var o=n.unicode;n.lastIndex=0;for(var a,l=[],c=0;null!==(a=le(n,s));){var u=String(a[0]);l[c]=u,""===u&&(n.lastIndex=ae(s,f(n.lastIndex),o)),c++}return 0===c?null:l}]});var de=Math.max,pe=Math.min,ve=Math.floor,ge=/\$([$&`']|\d\d?|<[^>]*>)/g,be=/\$([$&`']|\d\d?)/g;fe("replace",2,function(t,e,i){return[function(i,r){var n=o(this),s=null==i?void 0:i[t];return void 0!==s?s.call(i,n,r):e.call(String(n),i,r)},function(t,n){var s=i(e,t,this,n);if(s.done)return s.value;var o=L(t),a=String(this),l="function"==typeof n;l||(n=String(n));var c=o.global;if(c){var h=o.unicode;o.lastIndex=0}for(var d=[];;){var p=le(o,a);if(null===p)break;if(d.push(p),!c)break;""===String(p[0])&&(o.lastIndex=ae(a,f(o.lastIndex),h))}for(var v,g="",b=0,m=0;m<d.length;m++){p=d[m];for(var y=String(p[0]),x=de(pe(u(p.index),a.length),0),E=[],w=1;w<p.length;w++)E.push(void 0===(v=p[w])?v:String(v));var O=p.groups;if(l){var _=[y].concat(E,x,a);void 0!==O&&_.push(O);var S=String(n.apply(void 0,_))}else S=r(y,a,x,E,O,n);x>=b&&(g+=a.slice(b,x)+S,b=x+y.length)}return g+a.slice(b)}];function r(t,i,r,n,s,o){var l=r+t.length,c=n.length,u=be;return void 0!==s&&(s=a(s),u=ge),e.call(o,u,function(e,o){var a;switch(o.charAt(0)){case"$":return"$";case"&":return t;case"`":return i.slice(0,r);case"'":return i.slice(l);case"<":a=s[o.slice(1,-1)];break;default:var u=+o;if(0===u)return e;if(u>c){var h=ve(u/10);return 0===h?e:h<=c?void 0===n[h-1]?o.charAt(1):n[h-1]+o.charAt(1):e}a=n[u-1]}return void 0===a?"":a})}});for(var me in{CSSRuleList:0,CSSStyleDeclaration:0,CSSValueList:0,ClientRectList:0,DOMRectList:0,DOMStringList:0,DOMTokenList:1,DataTransferItemList:0,FileList:0,HTMLAllCollection:0,HTMLCollection:0,HTMLFormElement:0,HTMLSelectElement:0,MediaList:0,MimeTypeArray:0,NamedNodeMap:0,NodeList:1,PaintRequestList:0,Plugin:0,PluginArray:0,SVGLengthList:0,SVGNumberList:0,SVGPathSegList:0,SVGPointList:0,SVGStringList:0,SVGTransformList:0,SourceBufferList:0,StyleSheetList:0,TextTrackCueList:0,TextTrackList:0,TouchList:0}){var ye=E[me],xe=ye&&ye.prototype;if(xe&&xe.forEach!==Vt)try{T(xe,"forEach",Vt)}catch(t){xe.forEach=Vt}}var Ee="Expected a function",we=NaN,Oe="[object Symbol]",_e=/^\s+|\s+$/g,Se=/^[-+]0x[0-9a-f]+$/i,Le=/^0b[01]+$/i,Ae=/^0o[0-7]+$/i,ke=parseInt,Me="object"==typeof v&&v&&v.Object===Object&&v,We="object"==typeof self&&self&&self.Object===Object&&self,Te=Me||We||Function("return this")(),Re=Object.prototype.toString,je=Math.max,Ce=Math.min,Ne=function(){return Te.Date.now()};function ze(t,e,i){var r,n,s,o,a,l,c=0,u=!1,h=!1,f=!0;if("function"!=typeof t)throw new TypeError(Ee);function d(e){var i=r,s=n;return r=n=void 0,c=e,o=t.apply(s,i)}function p(t){var i=t-l;return void 0===l||i>=e||i<0||h&&t-c>=s}function v(){var t=Ne();if(p(t))return g(t);a=setTimeout(v,function(t){var i=e-(t-l);return h?Ce(i,s-(t-c)):i}(t))}function g(t){return a=void 0,f&&r?d(t):(r=n=void 0,o)}function b(){var t=Ne(),i=p(t);if(r=arguments,n=this,l=t,i){if(void 0===a)return function(t){return c=t,a=setTimeout(v,e),u?d(t):o}(l);if(h)return a=setTimeout(v,e),d(l)}return void 0===a&&(a=setTimeout(v,e)),o}return e=Ve(e)||0,De(i)&&(u=!!i.leading,s=(h="maxWait"in i)?je(Ve(i.maxWait)||0,e):s,f="trailing"in i?!!i.trailing:f),b.cancel=function(){void 0!==a&&clearTimeout(a),c=0,r=l=n=a=void 0},b.flush=function(){return void 0===a?o:g(Ne())},b}function De(t){var e=typeof t;return!!t&&("object"==e||"function"==e)}function Ve(t){if("number"==typeof t)return t;if(function(t){return"symbol"==typeof t||function(t){return!!t&&"object"==typeof t}(t)&&Re.call(t)==Oe}(t))return we;if(De(t)){var e="function"==typeof t.valueOf?t.valueOf():t;t=De(e)?e+"":e}if("string"!=typeof t)return 0===t?t:+t;t=t.replace(_e,"");var i=Le.test(t);return i||Ae.test(t)?ke(t.slice(2),i?2:8):Se.test(t)?we:+t}var Be=function(t,e,i){var r=!0,n=!0;if("function"!=typeof t)throw new TypeError(Ee);return De(i)&&(r="leading"in i?!!i.leading:r,n="trailing"in i?!!i.trailing:n),ze(t,e,{leading:r,maxWait:e,trailing:n})},Ie="Expected a function",Pe=NaN,He="[object Symbol]",qe=/^\s+|\s+$/g,Fe=/^[-+]0x[0-9a-f]+$/i,$e=/^0b[01]+$/i,Ye=/^0o[0-7]+$/i,Xe=parseInt,Ge="object"==typeof v&&v&&v.Object===Object&&v,Ke="object"==typeof self&&self&&self.Object===Object&&self,Ue=Ge||Ke||Function("return this")(),Je=Object.prototype.toString,Qe=Math.max,Ze=Math.min,ti=function(){return Ue.Date.now()};function ei(t){var e=typeof t;return!!t&&("object"==e||"function"==e)}function ii(t){if("number"==typeof t)return t;if(function(t){return"symbol"==typeof t||function(t){return!!t&&"object"==typeof t}(t)&&Je.call(t)==He}(t))return Pe;if(ei(t)){var e="function"==typeof t.valueOf?t.valueOf():t;t=ei(e)?e+"":e}if("string"!=typeof t)return 0===t?t:+t;t=t.replace(qe,"");var i=$e.test(t);return i||Ye.test(t)?Xe(t.slice(2),i?2:8):Fe.test(t)?Pe:+t}var ri=function(t,e,i){var r,n,s,o,a,l,c=0,u=!1,h=!1,f=!0;if("function"!=typeof t)throw new TypeError(Ie);function d(e){var i=r,s=n;return r=n=void 0,c=e,o=t.apply(s,i)}function p(t){var i=t-l;return void 0===l||i>=e||i<0||h&&t-c>=s}function v(){var t=ti();if(p(t))return g(t);a=setTimeout(v,function(t){var i=e-(t-l);return h?Ze(i,s-(t-c)):i}(t))}function g(t){return a=void 0,f&&r?d(t):(r=n=void 0,o)}function b(){var t=ti(),i=p(t);if(r=arguments,n=this,l=t,i){if(void 0===a)return function(t){return c=t,a=setTimeout(v,e),u?d(t):o}(l);if(h)return a=setTimeout(v,e),d(l)}return void 0===a&&(a=setTimeout(v,e)),o}return e=ii(e)||0,ei(i)&&(u=!!i.leading,s=(h="maxWait"in i)?Qe(ii(i.maxWait)||0,e):s,f="trailing"in i?!!i.trailing:f),b.cancel=function(){void 0!==a&&clearTimeout(a),c=0,r=l=n=a=void 0},b.flush=function(){return void 0===a?o:g(ti())},b},ni="Expected a function",si="__lodash_hash_undefined__",oi="[object Function]",ai="[object GeneratorFunction]",li=/^\[object .+?Constructor\]$/,ci="object"==typeof v&&v&&v.Object===Object&&v,ui="object"==typeof self&&self&&self.Object===Object&&self,hi=ci||ui||Function("return this")();var fi=Array.prototype,di=Function.prototype,pi=Object.prototype,vi=hi["__core-js_shared__"],gi=function(){var t=/[^.]+$/.exec(vi&&vi.keys&&vi.keys.IE_PROTO||"");return t?"Symbol(src)_1."+t:""}(),bi=di.toString,mi=pi.hasOwnProperty,yi=pi.toString,xi=RegExp("^"+bi.call(mi).replace(/[\\^$.*+?()[\]{}|]/g,"\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,"$1.*?")+"$"),Ei=fi.splice,wi=Wi(hi,"Map"),Oi=Wi(Object,"create");function _i(t){var e=-1,i=t?t.length:0;for(this.clear();++e<i;){var r=t[e];this.set(r[0],r[1])}}function Si(t){var e=-1,i=t?t.length:0;for(this.clear();++e<i;){var r=t[e];this.set(r[0],r[1])}}function Li(t){var e=-1,i=t?t.length:0;for(this.clear();++e<i;){var r=t[e];this.set(r[0],r[1])}}function Ai(t,e){for(var i,r,n=t.length;n--;)if((i=t[n][0])===(r=e)||i!=i&&r!=r)return n;return-1}function ki(t){return!(!Ri(t)||(e=t,gi&&gi in e))&&(function(t){var e=Ri(t)?yi.call(t):"";return e==oi||e==ai}(t)||function(t){var e=!1;if(null!=t&&"function"!=typeof t.toString)try{e=!!(t+"")}catch(t){}return e}(t)?xi:li).test(function(t){if(null!=t){try{return bi.call(t)}catch(t){}try{return t+""}catch(t){}}return""}(t));var e}function Mi(t,e){var i,r,n=t.__data__;return("string"==(r=typeof(i=e))||"number"==r||"symbol"==r||"boolean"==r?"__proto__"!==i:null===i)?n["string"==typeof e?"string":"hash"]:n.map}function Wi(t,e){var i=function(t,e){return null==t?void 0:t[e]}(t,e);return ki(i)?i:void 0}function Ti(t,e){if("function"!=typeof t||e&&"function"!=typeof e)throw new TypeError(ni);var i=function(){var r=arguments,n=e?e.apply(this,r):r[0],s=i.cache;if(s.has(n))return s.get(n);var o=t.apply(this,r);return i.cache=s.set(n,o),o};return i.cache=new(Ti.Cache||Li),i}function Ri(t){var e=typeof t;return!!t&&("object"==e||"function"==e)}_i.prototype.clear=function(){this.__data__=Oi?Oi(null):{}},_i.prototype.delete=function(t){return this.has(t)&&delete this.__data__[t]},_i.prototype.get=function(t){var e=this.__data__;if(Oi){var i=e[t];return i===si?void 0:i}return mi.call(e,t)?e[t]:void 0},_i.prototype.has=function(t){var e=this.__data__;return Oi?void 0!==e[t]:mi.call(e,t)},_i.prototype.set=function(t,e){return this.__data__[t]=Oi&&void 0===e?si:e,this},Si.prototype.clear=function(){this.__data__=[]},Si.prototype.delete=function(t){var e=this.__data__,i=Ai(e,t);return!(i<0||(i==e.length-1?e.pop():Ei.call(e,i,1),0))},Si.prototype.get=function(t){var e=this.__data__,i=Ai(e,t);return i<0?void 0:e[i][1]},Si.prototype.has=function(t){return Ai(this.__data__,t)>-1},Si.prototype.set=function(t,e){var i=this.__data__,r=Ai(i,t);return r<0?i.push([t,e]):i[r][1]=e,this},Li.prototype.clear=function(){this.__data__={hash:new _i,map:new(wi||Si),string:new _i}},Li.prototype.delete=function(t){return Mi(this,t).delete(t)},Li.prototype.get=function(t){return Mi(this,t).get(t)},Li.prototype.has=function(t){return Mi(this,t).has(t)},Li.prototype.set=function(t,e){return Mi(this,t).set(t,e),this},Ti.Cache=Li;var ji=Ti,Ci=function(){if("undefined"!=typeof Map)return Map;function t(t,e){var i=-1;return t.some(function(t,r){return t[0]===e&&(i=r,!0)}),i}return function(){function e(){this.__entries__=[]}return Object.defineProperty(e.prototype,"size",{get:function(){return this.__entries__.length},enumerable:!0,configurable:!0}),e.prototype.get=function(e){var i=t(this.__entries__,e),r=this.__entries__[i];return r&&r[1]},e.prototype.set=function(e,i){var r=t(this.__entries__,e);~r?this.__entries__[r][1]=i:this.__entries__.push([e,i])},e.prototype.delete=function(e){var i=this.__entries__,r=t(i,e);~r&&i.splice(r,1)},e.prototype.has=function(e){return!!~t(this.__entries__,e)},e.prototype.clear=function(){this.__entries__.splice(0)},e.prototype.forEach=function(t,e){void 0===e&&(e=null);for(var i=0,r=this.__entries__;i<r.length;i++){var n=r[i];t.call(e,n[1],n[0])}},e}()}(),Ni="undefined"!=typeof window&&"undefined"!=typeof document&&window.document===document,zi="undefined"!=typeof global&&global.Math===Math?global:"undefined"!=typeof self&&self.Math===Math?self:"undefined"!=typeof window&&window.Math===Math?window:Function("return this")(),Di="function"==typeof requestAnimationFrame?requestAnimationFrame.bind(zi):function(t){return setTimeout(function(){return t(Date.now())},1e3/60)},Vi=2;var Bi=20,Ii=["top","right","bottom","left","width","height","size","weight"],Pi="undefined"!=typeof MutationObserver,Hi=function(){function t(){this.connected_=!1,this.mutationEventsAdded_=!1,this.mutationsObserver_=null,this.observers_=[],this.onTransitionEnd_=this.onTransitionEnd_.bind(this),this.refresh=function(t,e){var i=!1,r=!1,n=0;function s(){i&&(i=!1,t()),r&&a()}function o(){Di(s)}function a(){var t=Date.now();if(i){if(t-n<Vi)return;r=!0}else i=!0,r=!1,setTimeout(o,e);n=t}return a}(this.refresh.bind(this),Bi)}return t.prototype.addObserver=function(t){~this.observers_.indexOf(t)||this.observers_.push(t),this.connected_||this.connect_()},t.prototype.removeObserver=function(t){var e=this.observers_,i=e.indexOf(t);~i&&e.splice(i,1),!e.length&&this.connected_&&this.disconnect_()},t.prototype.refresh=function(){this.updateObservers_()&&this.refresh()},t.prototype.updateObservers_=function(){var t=this.observers_.filter(function(t){return t.gatherActive(),t.hasActive()});return t.forEach(function(t){return t.broadcastActive()}),t.length>0},t.prototype.connect_=function(){Ni&&!this.connected_&&(document.addEventListener("transitionend",this.onTransitionEnd_),window.addEventListener("resize",this.refresh),Pi?(this.mutationsObserver_=new MutationObserver(this.refresh),this.mutationsObserver_.observe(document,{attributes:!0,childList:!0,characterData:!0,subtree:!0})):(document.addEventListener("DOMSubtreeModified",this.refresh),this.mutationEventsAdded_=!0),this.connected_=!0)},t.prototype.disconnect_=function(){Ni&&this.connected_&&(document.removeEventListener("transitionend",this.onTransitionEnd_),window.removeEventListener("resize",this.refresh),this.mutationsObserver_&&this.mutationsObserver_.disconnect(),this.mutationEventsAdded_&&document.removeEventListener("DOMSubtreeModified",this.refresh),this.mutationsObserver_=null,this.mutationEventsAdded_=!1,this.connected_=!1)},t.prototype.onTransitionEnd_=function(t){var e=t.propertyName,i=void 0===e?"":e;Ii.some(function(t){return!!~i.indexOf(t)})&&this.refresh()},t.getInstance=function(){return this.instance_||(this.instance_=new t),this.instance_},t.instance_=null,t}(),qi=function(t,e){for(var i=0,r=Object.keys(e);i<r.length;i++){var n=r[i];Object.defineProperty(t,n,{value:e[n],enumerable:!1,writable:!1,configurable:!0})}return t},Fi=function(t){return t&&t.ownerDocument&&t.ownerDocument.defaultView||zi},$i=Ji(0,0,0,0);function Yi(t){return parseFloat(t)||0}function Xi(t){for(var e=[],i=1;i<arguments.length;i++)e[i-1]=arguments[i];return e.reduce(function(e,i){return e+Yi(t["border-"+i+"-width"])},0)}function Gi(t){var e=t.clientWidth,i=t.clientHeight;if(!e&&!i)return $i;var r=Fi(t).getComputedStyle(t),n=function(t){for(var e={},i=0,r=["top","right","bottom","left"];i<r.length;i++){var n=r[i],s=t["padding-"+n];e[n]=Yi(s)}return e}(r),s=n.left+n.right,o=n.top+n.bottom,a=Yi(r.width),l=Yi(r.height);if("border-box"===r.boxSizing&&(Math.round(a+s)!==e&&(a-=Xi(r,"left","right")+s),Math.round(l+o)!==i&&(l-=Xi(r,"top","bottom")+o)),!function(t){return t===Fi(t).document.documentElement}(t)){var c=Math.round(a+s)-e,u=Math.round(l+o)-i;1!==Math.abs(c)&&(a-=c),1!==Math.abs(u)&&(l-=u)}return Ji(n.left,n.top,a,l)}var Ki="undefined"!=typeof SVGGraphicsElement?function(t){return t instanceof Fi(t).SVGGraphicsElement}:function(t){return t instanceof Fi(t).SVGElement&&"function"==typeof t.getBBox};function Ui(t){return Ni?Ki(t)?function(t){var e=t.getBBox();return Ji(0,0,e.width,e.height)}(t):Gi(t):$i}function Ji(t,e,i,r){return{x:t,y:e,width:i,height:r}}var Qi=function(){function t(t){this.broadcastWidth=0,this.broadcastHeight=0,this.contentRect_=Ji(0,0,0,0),this.target=t}return t.prototype.isActive=function(){var t=Ui(this.target);return this.contentRect_=t,t.width!==this.broadcastWidth||t.height!==this.broadcastHeight},t.prototype.broadcastRect=function(){var t=this.contentRect_;return this.broadcastWidth=t.width,this.broadcastHeight=t.height,t},t}(),Zi=function(){return function(t,e){var i,r,n,s,o,a,l,c=(r=(i=e).x,n=i.y,s=i.width,o=i.height,a="undefined"!=typeof DOMRectReadOnly?DOMRectReadOnly:Object,l=Object.create(a.prototype),qi(l,{x:r,y:n,width:s,height:o,top:n,right:r+s,bottom:o+n,left:r}),l);qi(this,{target:t,contentRect:c})}}(),tr=function(){function t(t,e,i){if(this.activeObservations_=[],this.observations_=new Ci,"function"!=typeof t)throw new TypeError("The callback provided as parameter 1 is not a function.");this.callback_=t,this.controller_=e,this.callbackCtx_=i}return t.prototype.observe=function(t){if(!arguments.length)throw new TypeError("1 argument required, but only 0 present.");if("undefined"!=typeof Element&&Element instanceof Object){if(!(t instanceof Fi(t).Element))throw new TypeError('parameter 1 is not of type "Element".');var e=this.observations_;e.has(t)||(e.set(t,new Qi(t)),this.controller_.addObserver(this),this.controller_.refresh())}},t.prototype.unobserve=function(t){if(!arguments.length)throw new TypeError("1 argument required, but only 0 present.");if("undefined"!=typeof Element&&Element instanceof Object){if(!(t instanceof Fi(t).Element))throw new TypeError('parameter 1 is not of type "Element".');var e=this.observations_;e.has(t)&&(e.delete(t),e.size||this.controller_.removeObserver(this))}},t.prototype.disconnect=function(){this.clearActive(),this.observations_.clear(),this.controller_.removeObserver(this)},t.prototype.gatherActive=function(){var t=this;this.clearActive(),this.observations_.forEach(function(e){e.isActive()&&t.activeObservations_.push(e)})},t.prototype.broadcastActive=function(){if(this.hasActive()){var t=this.callbackCtx_,e=this.activeObservations_.map(function(t){return new Zi(t.target,t.broadcastRect())});this.callback_.call(t,e,t),this.clearActive()}},t.prototype.clearActive=function(){this.activeObservations_.splice(0)},t.prototype.hasActive=function(){return this.activeObservations_.length>0},t}(),er="undefined"!=typeof WeakMap?new WeakMap:new Ci,ir=function(){return function t(e){if(!(this instanceof t))throw new TypeError("Cannot call a class as a function.");if(!arguments.length)throw new TypeError("1 argument required, but only 0 present.");var i=Hi.getInstance(),r=new tr(e,i,this);er.set(this,r)}}();["observe","unobserve","disconnect"].forEach(function(t){ir.prototype[t]=function(){var e;return(e=er.get(this))[t].apply(e,arguments)}});var rr=void 0!==zi.ResizeObserver?zi.ResizeObserver:ir,nr=!("undefined"==typeof window||!window.document||!window.document.createElement);function sr(){if("undefined"==typeof document)return 0;var t=document.body,e=document.createElement("div"),i=e.style;i.position="fixed",i.left=0,i.visibility="hidden",i.overflowY="scroll",t.appendChild(e);var r=e.getBoundingClientRect().right;return t.removeChild(e),r}var or=function(){function t(e,i){var r=this;this.onScroll=function(){r.scrollXTicking||(window.requestAnimationFrame(r.scrollX),r.scrollXTicking=!0),r.scrollYTicking||(window.requestAnimationFrame(r.scrollY),r.scrollYTicking=!0)},this.scrollX=function(){r.axis.x.isOverflowing&&(r.showScrollbar("x"),r.positionScrollbar("x")),r.scrollXTicking=!1},this.scrollY=function(){r.axis.y.isOverflowing&&(r.showScrollbar("y"),r.positionScrollbar("y")),r.scrollYTicking=!1},this.onMouseEnter=function(){r.showScrollbar("x"),r.showScrollbar("y")},this.onMouseMove=function(t){r.mouseX=t.clientX,r.mouseY=t.clientY,(r.axis.x.isOverflowing||r.axis.x.forceVisible)&&r.onMouseMoveForAxis("x"),(r.axis.y.isOverflowing||r.axis.y.forceVisible)&&r.onMouseMoveForAxis("y")},this.onMouseLeave=function(){r.onMouseMove.cancel(),(r.axis.x.isOverflowing||r.axis.x.forceVisible)&&r.onMouseLeaveForAxis("x"),(r.axis.y.isOverflowing||r.axis.y.forceVisible)&&r.onMouseLeaveForAxis("y"),r.mouseX=-1,r.mouseY=-1},this.onWindowResize=function(){r.scrollbarWidth=sr(),r.hideNativeScrollbar()},this.hideScrollbars=function(){r.axis.x.track.rect=r.axis.x.track.el.getBoundingClientRect(),r.axis.y.track.rect=r.axis.y.track.el.getBoundingClientRect(),r.isWithinBounds(r.axis.y.track.rect)||(r.axis.y.scrollbar.el.classList.remove(r.classNames.visible),r.axis.y.isVisible=!1),r.isWithinBounds(r.axis.x.track.rect)||(r.axis.x.scrollbar.el.classList.remove(r.classNames.visible),r.axis.x.isVisible=!1)},this.onPointerEvent=function(t){var e,i;r.axis.x.scrollbar.rect=r.axis.x.scrollbar.el.getBoundingClientRect(),r.axis.y.scrollbar.rect=r.axis.y.scrollbar.el.getBoundingClientRect(),(r.axis.x.isOverflowing||r.axis.x.forceVisible)&&(i=r.isWithinBounds(r.axis.x.scrollbar.rect)),(r.axis.y.isOverflowing||r.axis.y.forceVisible)&&(e=r.isWithinBounds(r.axis.y.scrollbar.rect)),(e||i)&&(t.preventDefault(),t.stopPropagation(),"mousedown"===t.type&&(e&&r.onDragStart(t,"y"),i&&r.onDragStart(t,"x")))},this.drag=function(e){var i=r.axis[r.draggedAxis].track,n=i.rect[r.axis[r.draggedAxis].sizeAttr],s=r.axis[r.draggedAxis].scrollbar;e.preventDefault(),e.stopPropagation();var o=(("y"===r.draggedAxis?e.pageY:e.pageX)-i.rect[r.axis[r.draggedAxis].offsetAttr]-r.axis[r.draggedAxis].dragOffset)/i.rect[r.axis[r.draggedAxis].sizeAttr]*r.contentWrapperEl[r.axis[r.draggedAxis].scrollSizeAttr];"x"===r.draggedAxis&&(o=r.isRtl&&t.getRtlHelpers().isRtlScrollbarInverted?o-(n+s.size):o,o=r.isRtl&&t.getRtlHelpers().isRtlScrollingInverted?-o:o),r.contentWrapperEl[r.axis[r.draggedAxis].scrollOffsetAttr]=o},this.onEndDrag=function(t){t.preventDefault(),t.stopPropagation(),r.el.classList.remove(r.classNames.dragging),document.removeEventListener("mousemove",r.drag,!0),document.removeEventListener("mouseup",r.onEndDrag,!0),r.removePreventClickId=window.setTimeout(function(){document.removeEventListener("click",r.preventClick,!0),document.removeEventListener("dblclick",r.preventClick,!0),r.removePreventClickId=null})},this.preventClick=function(t){t.preventDefault(),t.stopPropagation()},this.el=e,this.flashTimeout,this.contentEl,this.contentWrapperEl,this.offsetEl,this.maskEl,this.globalObserver,this.mutationObserver,this.resizeObserver,this.scrollbarWidth,this.minScrollbarWidth=20,this.options=Object.assign({},t.defaultOptions,i),this.classNames=Object.assign({},t.defaultOptions.classNames,this.options.classNames),this.isRtl,this.axis={x:{scrollOffsetAttr:"scrollLeft",sizeAttr:"width",scrollSizeAttr:"scrollWidth",offsetAttr:"left",overflowAttr:"overflowX",dragOffset:0,isOverflowing:!0,isVisible:!1,forceVisible:!1,track:{},scrollbar:{}},y:{scrollOffsetAttr:"scrollTop",sizeAttr:"height",scrollSizeAttr:"scrollHeight",offsetAttr:"top",overflowAttr:"overflowY",dragOffset:0,isOverflowing:!0,isVisible:!1,forceVisible:!1,track:{},scrollbar:{}}},this.removePreventClickId=null,this.el.SimpleBar||(this.recalculate=Be(this.recalculate.bind(this),64),this.onMouseMove=Be(this.onMouseMove.bind(this),64),this.hideScrollbars=ri(this.hideScrollbars.bind(this),this.options.timeout),this.onWindowResize=ri(this.onWindowResize.bind(this),64,{leading:!0}),t.getRtlHelpers=ji(t.getRtlHelpers),this.init())}t.getRtlHelpers=function(){var e=document.createElement("div");e.innerHTML='<div class="hs-dummy-scrollbar-size"><div style="height: 200%; width: 200%; margin: 10px 0;"></div></div>';var i=e.firstElementChild;document.body.appendChild(i);var r=i.firstElementChild;i.scrollLeft=0;var n=t.getOffset(i),s=t.getOffset(r);i.scrollLeft=999;var o=t.getOffset(r);return{isRtlScrollingInverted:n.left!==s.left&&s.left-o.left!=0,isRtlScrollbarInverted:n.left!==s.left}},t.initHtmlApi=function(){this.initDOMLoadedElements=this.initDOMLoadedElements.bind(this),"undefined"!=typeof MutationObserver&&(this.globalObserver=new MutationObserver(function(e){e.forEach(function(e){Array.prototype.forEach.call(e.addedNodes,function(e){1===e.nodeType&&(e.hasAttribute("data-simplebar")?!e.SimpleBar&&new t(e,t.getElOptions(e)):Array.prototype.forEach.call(e.querySelectorAll("[data-simplebar]"),function(e){!e.SimpleBar&&new t(e,t.getElOptions(e))}))}),Array.prototype.forEach.call(e.removedNodes,function(t){1===t.nodeType&&(t.hasAttribute("data-simplebar")?t.SimpleBar&&t.SimpleBar.unMount():Array.prototype.forEach.call(t.querySelectorAll("[data-simplebar]"),function(t){t.SimpleBar&&t.SimpleBar.unMount()}))})})}),this.globalObserver.observe(document,{childList:!0,subtree:!0})),"complete"===document.readyState||"loading"!==document.readyState&&!document.documentElement.doScroll?window.setTimeout(this.initDOMLoadedElements):(document.addEventListener("DOMContentLoaded",this.initDOMLoadedElements),window.addEventListener("load",this.initDOMLoadedElements))},t.getElOptions=function(t){return Array.prototype.reduce.call(t.attributes,function(t,e){var i=e.name.match(/data-simplebar-(.+)/);if(i){var r=i[1].replace(/\W+(.)/g,function(t,e){return e.toUpperCase()});switch(e.value){case"true":t[r]=!0;break;case"false":t[r]=!1;break;case void 0:t[r]=!0;break;default:t[r]=e.value}}return t},{})},t.removeObserver=function(){this.globalObserver.disconnect()},t.initDOMLoadedElements=function(){document.removeEventListener("DOMContentLoaded",this.initDOMLoadedElements),window.removeEventListener("load",this.initDOMLoadedElements),Array.prototype.forEach.call(document.querySelectorAll("[data-simplebar]"),function(e){e.SimpleBar||new t(e,t.getElOptions(e))})},t.getOffset=function(t){var e=t.getBoundingClientRect();return{top:e.top+(window.pageYOffset||document.documentElement.scrollTop),left:e.left+(window.pageXOffset||document.documentElement.scrollLeft)}};var e=t.prototype;return e.init=function(){this.el.SimpleBar=this,nr&&(this.initDOM(),this.scrollbarWidth=sr(),this.recalculate(),this.initListeners())},e.initDOM=function(){var t=this;if(Array.prototype.filter.call(this.el.children,function(e){return e.classList.contains(t.classNames.wrapper)}).length)this.wrapperEl=this.el.querySelector("."+this.classNames.wrapper),this.contentWrapperEl=this.el.querySelector("."+this.classNames.contentWrapper),this.offsetEl=this.el.querySelector("."+this.classNames.offset),this.maskEl=this.el.querySelector("."+this.classNames.mask),this.contentEl=this.el.querySelector("."+this.classNames.contentEl),this.placeholderEl=this.el.querySelector("."+this.classNames.placeholder),this.heightAutoObserverWrapperEl=this.el.querySelector("."+this.classNames.heightAutoObserverWrapperEl),this.heightAutoObserverEl=this.el.querySelector("."+this.classNames.heightAutoObserverEl),this.axis.x.track.el=this.el.querySelector("."+this.classNames.track+"."+this.classNames.horizontal),this.axis.y.track.el=this.el.querySelector("."+this.classNames.track+"."+this.classNames.vertical);else{for(this.wrapperEl=document.createElement("div"),this.contentWrapperEl=document.createElement("div"),this.offsetEl=document.createElement("div"),this.maskEl=document.createElement("div"),this.contentEl=document.createElement("div"),this.placeholderEl=document.createElement("div"),this.heightAutoObserverWrapperEl=document.createElement("div"),this.heightAutoObserverEl=document.createElement("div"),this.wrapperEl.classList.add(this.classNames.wrapper),this.contentWrapperEl.classList.add(this.classNames.contentWrapper),this.offsetEl.classList.add(this.classNames.offset),this.maskEl.classList.add(this.classNames.mask),this.contentEl.classList.add(this.classNames.contentEl),this.placeholderEl.classList.add(this.classNames.placeholder),this.heightAutoObserverWrapperEl.classList.add(this.classNames.heightAutoObserverWrapperEl),this.heightAutoObserverEl.classList.add(this.classNames.heightAutoObserverEl);this.el.firstChild;)this.contentEl.appendChild(this.el.firstChild);this.contentWrapperEl.appendChild(this.contentEl),this.offsetEl.appendChild(this.contentWrapperEl),this.maskEl.appendChild(this.offsetEl),this.heightAutoObserverWrapperEl.appendChild(this.heightAutoObserverEl),this.wrapperEl.appendChild(this.heightAutoObserverWrapperEl),this.wrapperEl.appendChild(this.maskEl),this.wrapperEl.appendChild(this.placeholderEl),this.el.appendChild(this.wrapperEl)}if(!this.axis.x.track.el||!this.axis.y.track.el){var e=document.createElement("div"),i=document.createElement("div");e.classList.add(this.classNames.track),i.classList.add(this.classNames.scrollbar),e.appendChild(i),this.axis.x.track.el=e.cloneNode(!0),this.axis.x.track.el.classList.add(this.classNames.horizontal),this.axis.y.track.el=e.cloneNode(!0),this.axis.y.track.el.classList.add(this.classNames.vertical),this.el.appendChild(this.axis.x.track.el),this.el.appendChild(this.axis.y.track.el)}this.axis.x.scrollbar.el=this.axis.x.track.el.querySelector("."+this.classNames.scrollbar),this.axis.y.scrollbar.el=this.axis.y.track.el.querySelector("."+this.classNames.scrollbar),this.options.autoHide||(this.axis.x.scrollbar.el.classList.add(this.classNames.visible),this.axis.y.scrollbar.el.classList.add(this.classNames.visible)),this.el.setAttribute("data-simplebar","init")},e.initListeners=function(){var t=this;this.options.autoHide&&this.el.addEventListener("mouseenter",this.onMouseEnter),["mousedown","click","dblclick","touchstart","touchend","touchmove"].forEach(function(e){t.el.addEventListener(e,t.onPointerEvent,!0)}),this.el.addEventListener("mousemove",this.onMouseMove),this.el.addEventListener("mouseleave",this.onMouseLeave),this.contentWrapperEl.addEventListener("scroll",this.onScroll),window.addEventListener("resize",this.onWindowResize),this.resizeObserver=new rr(this.recalculate),this.resizeObserver.observe(this.el),this.resizeObserver.observe(this.contentEl)},e.recalculate=function(){var t=this.heightAutoObserverEl.offsetHeight<=1,e=this.heightAutoObserverEl.offsetWidth<=1;this.elStyles=window.getComputedStyle(this.el),this.isRtl="rtl"===this.elStyles.direction,this.contentEl.style.padding=this.elStyles.paddingTop+" "+this.elStyles.paddingRight+" "+this.elStyles.paddingBottom+" "+this.elStyles.paddingLeft,this.wrapperEl.style.margin="-"+this.elStyles.paddingTop+" -"+this.elStyles.paddingRight+" -"+this.elStyles.paddingBottom+" -"+this.elStyles.paddingLeft,this.contentWrapperEl.style.height=t?"auto":"100%",this.placeholderEl.style.width=e?this.contentEl.offsetWidth+"px":"auto",this.placeholderEl.style.height=this.contentEl.scrollHeight+"px",this.axis.x.isOverflowing=this.contentWrapperEl.scrollWidth>this.contentWrapperEl.offsetWidth,this.axis.y.isOverflowing=this.contentWrapperEl.scrollHeight>this.contentWrapperEl.offsetHeight,this.axis.x.isOverflowing="hidden"!==this.elStyles.overflowX&&this.axis.x.isOverflowing,this.axis.y.isOverflowing="hidden"!==this.elStyles.overflowY&&this.axis.y.isOverflowing,this.axis.x.forceVisible="x"===this.options.forceVisible||!0===this.options.forceVisible,this.axis.y.forceVisible="y"===this.options.forceVisible||!0===this.options.forceVisible,this.hideNativeScrollbar(),this.axis.x.track.rect=this.axis.x.track.el.getBoundingClientRect(),this.axis.y.track.rect=this.axis.y.track.el.getBoundingClientRect(),this.axis.x.scrollbar.size=this.getScrollbarSize("x"),this.axis.y.scrollbar.size=this.getScrollbarSize("y"),this.axis.x.scrollbar.el.style.width=this.axis.x.scrollbar.size+"px",this.axis.y.scrollbar.el.style.height=this.axis.y.scrollbar.size+"px",this.positionScrollbar("x"),this.positionScrollbar("y"),this.toggleTrackVisibility("x"),this.toggleTrackVisibility("y")},e.getScrollbarSize=function(t){void 0===t&&(t="y");var e,i=this.scrollbarWidth?this.contentWrapperEl[this.axis[t].scrollSizeAttr]:this.contentWrapperEl[this.axis[t].scrollSizeAttr]-this.minScrollbarWidth,r=this.axis[t].track.rect[this.axis[t].sizeAttr];if(this.axis[t].isOverflowing){var n=r/i;return e=Math.max(~~(n*r),this.options.scrollbarMinSize),this.options.scrollbarMaxSize&&(e=Math.min(e,this.options.scrollbarMaxSize)),e}},e.positionScrollbar=function(e){void 0===e&&(e="y");var i=this.contentWrapperEl[this.axis[e].scrollSizeAttr],r=this.axis[e].track.rect[this.axis[e].sizeAttr],n=parseInt(this.elStyles[this.axis[e].sizeAttr],10),s=this.axis[e].scrollbar,o=this.contentWrapperEl[this.axis[e].scrollOffsetAttr],a=(o="x"===e&&this.isRtl&&t.getRtlHelpers().isRtlScrollingInverted?-o:o)/(i-n),l=~~((r-s.size)*a);l="x"===e&&this.isRtl&&t.getRtlHelpers().isRtlScrollbarInverted?l+(r-s.size):l,s.el.style.transform="x"===e?"translate3d("+l+"px, 0, 0)":"translate3d(0, "+l+"px, 0)"},e.toggleTrackVisibility=function(t){void 0===t&&(t="y");var e=this.axis[t].track.el,i=this.axis[t].scrollbar.el;this.axis[t].isOverflowing||this.axis[t].forceVisible?(e.style.visibility="visible",this.contentWrapperEl.style[this.axis[t].overflowAttr]="scroll"):(e.style.visibility="hidden",this.contentWrapperEl.style[this.axis[t].overflowAttr]="hidden"),this.axis[t].isOverflowing?i.style.display="block":i.style.display="none"},e.hideNativeScrollbar=function(){if(this.offsetEl.style[this.isRtl?"left":"right"]=this.axis.y.isOverflowing||this.axis.y.forceVisible?"-"+(this.scrollbarWidth||this.minScrollbarWidth)+"px":0,this.offsetEl.style.bottom=this.axis.x.isOverflowing||this.axis.x.forceVisible?"-"+(this.scrollbarWidth||this.minScrollbarWidth)+"px":0,!this.scrollbarWidth){var t=[this.isRtl?"paddingLeft":"paddingRight"];this.contentWrapperEl.style[t]=this.axis.y.isOverflowing||this.axis.y.forceVisible?this.minScrollbarWidth+"px":0,this.contentWrapperEl.style.paddingBottom=this.axis.x.isOverflowing||this.axis.x.forceVisible?this.minScrollbarWidth+"px":0}},e.onMouseMoveForAxis=function(t){void 0===t&&(t="y"),this.axis[t].track.rect=this.axis[t].track.el.getBoundingClientRect(),this.axis[t].scrollbar.rect=this.axis[t].scrollbar.el.getBoundingClientRect(),this.isWithinBounds(this.axis[t].scrollbar.rect)?this.axis[t].scrollbar.el.classList.add(this.classNames.hover):this.axis[t].scrollbar.el.classList.remove(this.classNames.hover),this.isWithinBounds(this.axis[t].track.rect)?(this.showScrollbar(t),this.axis[t].track.el.classList.add(this.classNames.hover)):this.axis[t].track.el.classList.remove(this.classNames.hover)},e.onMouseLeaveForAxis=function(t){void 0===t&&(t="y"),this.axis[t].track.el.classList.remove(this.classNames.hover),this.axis[t].scrollbar.el.classList.remove(this.classNames.hover)},e.showScrollbar=function(t){void 0===t&&(t="y");var e=this.axis[t].scrollbar.el;this.axis[t].isVisible||(e.classList.add(this.classNames.visible),this.axis[t].isVisible=!0),this.options.autoHide&&this.hideScrollbars()},e.onDragStart=function(t,e){void 0===e&&(e="y");var i=this.axis[e].scrollbar.el,r="y"===e?t.pageY:t.pageX;this.axis[e].dragOffset=r-i.getBoundingClientRect()[this.axis[e].offsetAttr],this.draggedAxis=e,this.el.classList.add(this.classNames.dragging),document.addEventListener("mousemove",this.drag,!0),document.addEventListener("mouseup",this.onEndDrag,!0),null===this.removePreventClickId?(document.addEventListener("click",this.preventClick,!0),document.addEventListener("dblclick",this.preventClick,!0)):(window.clearTimeout(this.removePreventClickId),this.removePreventClickId=null)},e.getContentElement=function(){return this.contentEl},e.getScrollElement=function(){return this.contentWrapperEl},e.removeListeners=function(){var t=this;this.options.autoHide&&this.el.removeEventListener("mouseenter",this.onMouseEnter),["mousedown","click","dblclick","touchstart","touchend","touchmove"].forEach(function(e){t.el.removeEventListener(e,t.onPointerEvent)}),this.el.removeEventListener("mousemove",this.onMouseMove),this.el.removeEventListener("mouseleave",this.onMouseLeave),this.contentWrapperEl.removeEventListener("scroll",this.onScroll),window.removeEventListener("resize",this.onWindowResize),this.mutationObserver&&this.mutationObserver.disconnect(),this.resizeObserver.disconnect(),this.recalculate.cancel(),this.onMouseMove.cancel(),this.hideScrollbars.cancel(),this.onWindowResize.cancel()},e.unMount=function(){this.removeListeners(),this.el.SimpleBar=null},e.isChildNode=function(t){return null!==t&&(t===this.el||this.isChildNode(t.parentNode))},e.isWithinBounds=function(t){return this.mouseX>=t.left&&this.mouseX<=t.left+t.width&&this.mouseY>=t.top&&this.mouseY<=t.top+t.height},t}();return or.defaultOptions={autoHide:!0,forceVisible:!1,classNames:{contentEl:"simplebar-content",contentWrapper:"simplebar-content-wrapper",offset:"simplebar-offset",mask:"simplebar-mask",wrapper:"simplebar-wrapper",placeholder:"simplebar-placeholder",scrollbar:"simplebar-scrollbar",track:"simplebar-track",heightAutoObserverWrapperEl:"simplebar-height-auto-observer-wrapper",heightAutoObserverEl:"simplebar-height-auto-observer",visible:"simplebar-visible",horizontal:"simplebar-horizontal",vertical:"simplebar-vertical",hover:"simplebar-hover",dragging:"simplebar-dragging"},scrollbarMinSize:25,scrollbarMaxSize:0,timeout:1e3},nr&&or.initHtmlApi(),or});

/*! lazysizes - v4.0.1 */
!function(a,b){var c=b(a,a.document);a.lazySizes=c,"object"==typeof module&&module.exports&&(module.exports=c)}(window,function(a,b){"use strict";if(b.getElementsByClassName){var c,d,e=b.documentElement,f=a.Date,g=a.HTMLPictureElement,h="addEventListener",i="getAttribute",j=a[h],k=a.setTimeout,l=a.requestAnimationFrame||k,m=a.requestIdleCallback,n=/^picture$/i,o=["load","error","lazyincluded","_lazyloaded"],p={},q=Array.prototype.forEach,r=function(a,b){return p[b]||(p[b]=new RegExp("(\\s|^)"+b+"(\\s|$)")),p[b].test(a[i]("class")||"")&&p[b]},s=function(a,b){r(a,b)||a.setAttribute("class",(a[i]("class")||"").trim()+" "+b)},t=function(a,b){var c;(c=r(a,b))&&a.setAttribute("class",(a[i]("class")||"").replace(c," "))},u=function(a,b,c){var d=c?h:"removeEventListener";c&&u(a,b),o.forEach(function(c){a[d](c,b)})},v=function(a,d,e,f,g){var h=b.createEvent("CustomEvent");return e||(e={}),e.instance=c,h.initCustomEvent(d,!f,!g,e),a.dispatchEvent(h),h},w=function(b,c){var e;!g&&(e=a.picturefill||d.pf)?e({reevaluate:!0,elements:[b]}):c&&c.src&&(b.src=c.src)},x=function(a,b){return(getComputedStyle(a,null)||{})[b]},y=function(a,b,c){for(c=c||a.offsetWidth;c<d.minSize&&b&&!a._lazysizesWidth;)c=b.offsetWidth,b=b.parentNode;return c},z=function(){var a,c,d=[],e=[],f=d,g=function(){var b=f;for(f=d.length?e:d,a=!0,c=!1;b.length;)b.shift()();a=!1},h=function(d,e){a&&!e?d.apply(this,arguments):(f.push(d),c||(c=!0,(b.hidden?k:l)(g)))};return h._lsFlush=g,h}(),A=function(a,b){return b?function(){z(a)}:function(){var b=this,c=arguments;z(function(){a.apply(b,c)})}},B=function(a){var b,c=0,e=125,g=d.ricTimeout,h=function(){b=!1,c=f.now(),a()},i=m&&d.ricTimeout?function(){m(h,{timeout:g}),g!==d.ricTimeout&&(g=d.ricTimeout)}:A(function(){k(h)},!0);return function(a){var d;(a=a===!0)&&(g=33),b||(b=!0,d=e-(f.now()-c),0>d&&(d=0),a||9>d&&m?i():k(i,d))}},C=function(a){var b,c,d=99,e=function(){b=null,a()},g=function(){var a=f.now()-c;d>a?k(g,d-a):(m||e)(e)};return function(){c=f.now(),b||(b=k(g,d))}};!function(){var b,c={lazyClass:"lazyload",loadedClass:"lazyloaded",loadingClass:"lazyloading",preloadClass:"lazypreload",errorClass:"lazyerror",autosizesClass:"lazyautosizes",srcAttr:"data-src",srcsetAttr:"data-srcset",sizesAttr:"data-sizes",minSize:40,customMedia:{},init:!0,expFactor:1.5,hFac:.8,loadMode:2,loadHidden:!0,ricTimeout:300};d=a.lazySizesConfig||a.lazysizesConfig||{};for(b in c)b in d||(d[b]=c[b]);a.lazySizesConfig=d,k(function(){d.init&&F()})}();var D=function(){var g,l,m,o,p,y,D,F,G,H,I,J,K,L,M=/^img$/i,N=/^iframe$/i,O="onscroll"in a&&!/glebot/.test(navigator.userAgent),P=0,Q=0,R=0,S=-1,T=function(a){R--,a&&a.target&&u(a.target,T),(!a||0>R||!a.target)&&(R=0)},U=function(a,c){var d,f=a,g="hidden"==x(b.body,"visibility")||"hidden"!=x(a,"visibility");for(F-=c,I+=c,G-=c,H+=c;g&&(f=f.offsetParent)&&f!=b.body&&f!=e;)g=(x(f,"opacity")||1)>0,g&&"visible"!=x(f,"overflow")&&(d=f.getBoundingClientRect(),g=H>d.left&&G<d.right&&I>d.top-1&&F<d.bottom+1);return g},V=function(){var a,f,h,j,k,m,n,p,q,r=c.elements;if((o=d.loadMode)&&8>R&&(a=r.length)){f=0,S++,null==K&&("expand"in d||(d.expand=e.clientHeight>500&&e.clientWidth>500?500:370),J=d.expand,K=J*d.expFactor),K>Q&&1>R&&S>2&&o>2&&!b.hidden?(Q=K,S=0):Q=o>1&&S>1&&6>R?J:P;for(;a>f;f++)if(r[f]&&!r[f]._lazyRace)if(O)if((p=r[f][i]("data-expand"))&&(m=1*p)||(m=Q),q!==m&&(y=innerWidth+m*L,D=innerHeight+m,n=-1*m,q=m),h=r[f].getBoundingClientRect(),(I=h.bottom)>=n&&(F=h.top)<=D&&(H=h.right)>=n*L&&(G=h.left)<=y&&(I||H||G||F)&&(d.loadHidden||"hidden"!=x(r[f],"visibility"))&&(l&&3>R&&!p&&(3>o||4>S)||U(r[f],m))){if(ba(r[f]),k=!0,R>9)break}else!k&&l&&!j&&4>R&&4>S&&o>2&&(g[0]||d.preloadAfterLoad)&&(g[0]||!p&&(I||H||G||F||"auto"!=r[f][i](d.sizesAttr)))&&(j=g[0]||r[f]);else ba(r[f]);j&&!k&&ba(j)}},W=B(V),X=function(a){s(a.target,d.loadedClass),t(a.target,d.loadingClass),u(a.target,Z),v(a.target,"lazyloaded")},Y=A(X),Z=function(a){Y({target:a.target})},$=function(a,b){try{a.contentWindow.location.replace(b)}catch(c){a.src=b}},_=function(a){var b,c=a[i](d.srcsetAttr);(b=d.customMedia[a[i]("data-media")||a[i]("media")])&&a.setAttribute("media",b),c&&a.setAttribute("srcset",c)},aa=A(function(a,b,c,e,f){var g,h,j,l,o,p;(o=v(a,"lazybeforeunveil",b)).defaultPrevented||(e&&(c?s(a,d.autosizesClass):a.setAttribute("sizes",e)),h=a[i](d.srcsetAttr),g=a[i](d.srcAttr),f&&(j=a.parentNode,l=j&&n.test(j.nodeName||"")),p=b.firesLoad||"src"in a&&(h||g||l),o={target:a},p&&(u(a,T,!0),clearTimeout(m),m=k(T,2500),s(a,d.loadingClass),u(a,Z,!0)),l&&q.call(j.getElementsByTagName("source"),_),h?a.setAttribute("srcset",h):g&&!l&&(N.test(a.nodeName)?$(a,g):a.src=g),f&&(h||l)&&w(a,{src:g})),a._lazyRace&&delete a._lazyRace,t(a,d.lazyClass),z(function(){(!p||a.complete&&a.naturalWidth>1)&&(p?T(o):R--,X(o))},!0)}),ba=function(a){var b,c=M.test(a.nodeName),e=c&&(a[i](d.sizesAttr)||a[i]("sizes")),f="auto"==e;(!f&&l||!c||!a[i]("src")&&!a.srcset||a.complete||r(a,d.errorClass)||!r(a,d.lazyClass))&&(b=v(a,"lazyunveilread").detail,f&&E.updateElem(a,!0,a.offsetWidth),a._lazyRace=!0,R++,aa(a,b,f,e,c))},ca=function(){if(!l){if(f.now()-p<999)return void k(ca,999);var a=C(function(){d.loadMode=3,W()});l=!0,d.loadMode=3,W(),j("scroll",function(){3==d.loadMode&&(d.loadMode=2),a()},!0)}};return{_:function(){p=f.now(),c.elements=b.getElementsByClassName(d.lazyClass),g=b.getElementsByClassName(d.lazyClass+" "+d.preloadClass),L=d.hFac,j("scroll",W,!0),j("resize",W,!0),a.MutationObserver?new MutationObserver(W).observe(e,{childList:!0,subtree:!0,attributes:!0}):(e[h]("DOMNodeInserted",W,!0),e[h]("DOMAttrModified",W,!0),setInterval(W,999)),j("hashchange",W,!0),["focus","mouseover","click","load","transitionend","animationend","webkitAnimationEnd"].forEach(function(a){b[h](a,W,!0)}),/d$|^c/.test(b.readyState)?ca():(j("load",ca),b[h]("DOMContentLoaded",W),k(ca,2e4)),c.elements.length?(V(),z._lsFlush()):W()},checkElems:W,unveil:ba}}(),E=function(){var a,c=A(function(a,b,c,d){var e,f,g;if(a._lazysizesWidth=d,d+="px",a.setAttribute("sizes",d),n.test(b.nodeName||""))for(e=b.getElementsByTagName("source"),f=0,g=e.length;g>f;f++)e[f].setAttribute("sizes",d);c.detail.dataAttr||w(a,c.detail)}),e=function(a,b,d){var e,f=a.parentNode;f&&(d=y(a,f,d),e=v(a,"lazybeforesizes",{width:d,dataAttr:!!b}),e.defaultPrevented||(d=e.detail.width,d&&d!==a._lazysizesWidth&&c(a,f,e,d)))},f=function(){var b,c=a.length;if(c)for(b=0;c>b;b++)e(a[b])},g=C(f);return{_:function(){a=b.getElementsByClassName(d.autosizesClass),j("resize",g)},checkElems:g,updateElem:e}}(),F=function(){F.i||(F.i=!0,E._(),D._())};return c={cfg:d,autoSizer:E,loader:D,init:F,uP:w,aC:s,rC:t,hC:r,fire:v,gW:y,rAF:z}}});
/*! lazysizes - rias */
!function(a,b){var c=function(){b(a.lazySizes),a.removeEventListener("lazyunveilread",c,!0)};b=b.bind(null,a,a.document),"object"==typeof module&&module.exports?b(require("lazysizes")):a.lazySizes?c():a.addEventListener("lazyunveilread",c,!0)}(window,function(a,b,c){"use strict";function d(b,c){var d,e,f,g,h=a.getComputedStyle(b);e=b.parentNode,g={isPicture:!(!e||!m.test(e.nodeName||""))},f=function(a,c){var d=b.getAttribute("data-"+a);if(!d){var e=h.getPropertyValue("--ls-"+a);e&&(d=e.trim())}if(d){if("true"==d)d=!0;else if("false"==d)d=!1;else if(l.test(d))d=parseFloat(d);else if("function"==typeof j[a])d=j[a](b,d);else if(q.test(d))try{d=JSON.parse(d)}catch(f){}g[a]=d}else a in j&&"function"!=typeof j[a]?g[a]=j[a]:c&&"function"==typeof j[a]&&(g[a]=j[a](b,d))};for(d in j)f(d);return c.replace(p,function(a,b){b in g||f(b,!0)}),g}function e(a,b){var c=[],d=function(a,c){return k[typeof b[c]]?b[c]:a};return c.srcset=[],b.absUrl&&(s.setAttribute("href",a),a=s.href),a=((b.prefix||"")+a+(b.postfix||"")).replace(p,d),b.widths.forEach(function(d){var e=b.widthmap[d]||d,f={u:a.replace(n,e).replace(o,b.ratio?Math.round(d*b.ratio):""),w:d};c.push(f),c.srcset.push(f.c=f.u+" "+d+"w")}),c}function f(a,c,d){var f=0,g=0,h=d;if(a){if("container"===c.ratio){for(f=h.scrollWidth,g=h.scrollHeight;!(f&&g||h===b);)h=h.parentNode,f=h.scrollWidth,g=h.scrollHeight;f&&g&&(c.ratio=g/f)}a=e(a,c),a.isPicture=c.isPicture,u&&"IMG"==d.nodeName.toUpperCase()?d.removeAttribute(i.srcsetAttr):d.setAttribute(i.srcsetAttr,a.srcset.join(", ")),Object.defineProperty(d,"_lazyrias",{value:a,writable:!0})}}function g(a,b){var e=d(a,b);return j.modifyOptions.call(a,{target:a,details:e,detail:e}),c.fire(a,"lazyriasmodifyoptions",e),e}function h(a){return a.getAttribute(a.getAttribute("data-srcattr")||j.srcAttr)||a.getAttribute(i.srcsetAttr)||a.getAttribute(i.srcAttr)||a.getAttribute("data-pfsrcset")||""}var i,j,k={string:1,number:1},l=/^\-*\+*\d+\.*\d*$/,m=/^picture$/i,n=/\s*\{\s*width\s*\}\s*/i,o=/\s*\{\s*height\s*\}\s*/i,p=/\s*\{\s*([a-z0-9]+)\s*\}\s*/gi,q=/^\[.*\]|\{.*\}$/,r=/^(?:auto|\d+(px)?)$/,s=b.createElement("a"),t=b.createElement("img"),u="srcset"in t&&!("sizes"in t),v=!!a.HTMLPictureElement&&!u;!function(){var b,d=function(){},e={prefix:"",postfix:"",srcAttr:"data-src",absUrl:!1,modifyOptions:d,widthmap:{},ratio:!1};i=c&&c.cfg||a.lazySizesConfig,i||(i={},a.lazySizesConfig=i),i.supportsType||(i.supportsType=function(a){return!a}),i.rias||(i.rias={}),j=i.rias,"widths"in j||(j.widths=[],function(a){for(var b,c=0;!b||3e3>b;)c+=5,c>30&&(c+=1),b=36*c,a.push(b)}(j.widths));for(b in e)b in j||(j[b]=e[b])}(),addEventListener("lazybeforesizes",function(a){if(a.detail.instance==c){var b,d,e,k,l,m,o,p,q,s,t,u,x;if(b=a.target,a.detail.dataAttr&&!a.defaultPrevented&&!j.disabled&&(q=b.getAttribute(i.sizesAttr)||b.getAttribute("sizes"))&&r.test(q)){if(d=h(b),e=g(b,d),t=n.test(e.prefix)||n.test(e.postfix),e.isPicture&&(k=b.parentNode))for(l=k.getElementsByTagName("source"),m=0,o=l.length;o>m;m++)(t||n.test(p=h(l[m])))&&(f(p,e,l[m]),u=!0);t||n.test(d)?(f(d,e,b),u=!0):u&&(x=[],x.srcset=[],x.isPicture=!0,Object.defineProperty(b,"_lazyrias",{value:x,writable:!0})),u&&(v?b.removeAttribute(i.srcAttr):"auto"!=q&&(s={width:parseInt(q,10)},w({target:b,detail:s})))}}},!0);var w=function(){var d=function(a,b){return a.w-b.w},e=function(a){var b,c,d=a.length,e=a[d-1],f=0;for(f;d>f;f++)if(e=a[f],e.d=e.w/a.w,e.d>=a.d){!e.cached&&(b=a[f-1])&&b.d>a.d-.13*Math.pow(a.d,2.2)&&(c=Math.pow(b.d-.6,1.6),b.cached&&(b.d+=.15*c),b.d+(e.d-a.d)*c>a.d&&(e=b));break}return e},f=function(a,b){var d;return!a._lazyrias&&c.pWS&&(d=c.pWS(a.getAttribute(i.srcsetAttr||""))).length&&(Object.defineProperty(a,"_lazyrias",{value:d,writable:!0}),b&&a.parentNode&&(d.isPicture="PICTURE"==a.parentNode.nodeName.toUpperCase())),a._lazyrias},g=function(b){var d=a.devicePixelRatio||1,e=c.getX&&c.getX(b);return Math.min(e||d,2.4,d)},h=function(b,c){var h,i,j,k,l,m;if(l=b._lazyrias,l.isPicture&&a.matchMedia)for(i=0,h=b.parentNode.getElementsByTagName("source"),j=h.length;j>i;i++)if(f(h[i])&&!h[i].getAttribute("type")&&(!(k=h[i].getAttribute("media"))||(matchMedia(k)||{}).matches)){l=h[i]._lazyrias;break}return(!l.w||l.w<c)&&(l.w=c,l.d=g(b),m=e(l.sort(d))),m},j=function(d){if(d.detail.instance==c){var e,g=d.target;return!u&&(a.respimage||a.picturefill||lazySizesConfig.pf)?void b.removeEventListener("lazybeforesizes",j):void(("_lazyrias"in g||d.detail.dataAttr&&f(g,!0))&&(e=h(g,d.detail.width),e&&e.u&&g._lazyrias.cur!=e.u&&(g._lazyrias.cur=e.u,e.cached=!0,c.rAF(function(){g.setAttribute(i.srcAttr,e.u),g.setAttribute("src",e.u)}))))}};return v?j=function(){}:addEventListener("lazybeforesizes",j),j}()});
/* lazysizes - optimumx */
!function(a,b,c){"use strict";if(a.addEventListener){var d,e=/^picture$/i,f=b.documentElement,g=function(){var a,b=/(([^,\s].[^\s]+)\s+(\d+)(w|h)(\s+(\d+)(w|h))?)/g,c=function(b,c,d,e,f,g,h,i){a.push({c:c,u:d,w:1*("w"==i?h:e)})};return function(d){return a=[],d.replace(b,c),a}}(),h=function(){var a=function(a,b){return a.w-b.w},b=function(b,c){var d={srcset:b.getAttribute(lazySizes.cfg.srcsetAttr)||""},e=g(d.srcset);return Object.defineProperty(b,c,{value:d,writable:!0}),d.cands=e,d.index=0,d.dirty=!1,e[0]&&e[0].w?(e.sort(a),d.cSrcset=[e[d.index].c]):(d.cSrcset=d.srcset?[d.srcset]:[],d.cands=[]),d};return function(a,c){var d,f,g,h;if(!a[c]&&(h=a.parentNode||{},a[c]=b(a,c),a[c].isImg=!0,e.test(h.nodeName||"")))for(a[c].picture=!0,d=h.getElementsByTagName("source"),f=0,g=d.length;g>f;f++)b(d[f],c).isImg=!1;return a[c]}}(),i={_lazyOptimumx:function(){var a=function(a,b,c){var d,e,f;return a&&a.d?(f=c>.7?.6:.4,a.d>=c?!1:(e=Math.pow(a.d-f,1.6)||.1,.1>e?e=.1:e>3&&(e=3),d=a.d+(b-c)*e,c>d)):!0};return function(b,c,d){var e,f;for(e=0;e<b.cands.length;e++)if(f=b.cands[e],f.d=(f.w||1)/c,!(b.index>=e)){if(!(f.d<=d||a(b.cands[e-1],f.d,d)))break;b.cSrcset.push(f.c),b.index=e}}}()},j=function(){var a=function(a,b,c,d,e){var f,g=a[e];g&&(f=g.index,i[e](g,b,c),g.dirty&&f==g.index||(g.cSrcset.join(", "),a.setAttribute(d,g.cSrcset.join(", ")),g.dirty=!0))};return function(b,c,d,e,f){var g,h,i,j,k=b[f];if(k.width=c,k.picture&&(h=b.parentNode))for(g=h.getElementsByTagName("source"),j=0,i=g.length;i>j;j++)a(g[j],c,d,e,f);a(b,c,d,e,f)}}(),k=function(a){var b=a.getAttribute("data-optimumx")||a.getAttribute("data-maxdpr");return!b&&d.constrainPixelDensity&&(b="auto"),b&&(b="auto"==b?d.getOptimumX(a):parseFloat(b,10)),b},l=function(){a.lazySizes&&!a.lazySizes.getOptimumX&&(lazySizes.getX=k,lazySizes.pWS=g,f.removeEventListener("lazybeforeunveil",l))};f.addEventListener("lazybeforeunveil",l),setTimeout(l),d=a.lazySizes&&lazySizes.cfg||a.lazySizesConfig,d||(d={},a.lazySizesConfig=d),"function"!=typeof d.getOptimumX&&(d.getOptimumX=function(){var b=a.devicePixelRatio||1;return b>2.6?b*=.6:b>1.9?b*=.8:b-=.01,Math.min(Math.round(100*b)/100,2)}),a.devicePixelRatio&&addEventListener("lazybeforesizes",function(a){var b,c,e,f,g=a.target,i=a.detail,l=i.dataAttr;a.defaultPrevented||!(b=k(g))||b>=devicePixelRatio||(!l||!g._lazyOptimumx||i.reloaded||d.unloadedClass&&lazySizes.hC(g,d.unloadedClass)||(g._lazyOptimumx=null),c=h(g,"_lazyOptimumx"),e=i.width,e&&(c.width||0)<e&&(f=l?lazySizes.cfg.srcsetAttr:"srcset",lazySizes.rAF(function(){j(g,e,b,f,"_lazyOptimumx")})))})}}(window,document);
/* lazysizes - progressive */
!function(a,b){var c=function(){b(a.lazySizes),a.removeEventListener("lazyunveilread",c,!0)};b=b.bind(null,a,a.document),"object"==typeof module&&module.exports?b(require("lazysizes")):a.lazySizes?c():a.addEventListener("lazyunveilread",c,!0)}(window,function(a,b,c){"use strict";var d,e;"srcset"in b.createElement("img")&&(d=/^img$/i,e=function(a){a.target.style.backgroundSize="",a.target.style.backgroundImage="",a.target.removeEventListener(a.type,e)},b.addEventListener("lazybeforeunveil",function(a){if(a.detail.instance==c){var b=a.target;if(d.test(b.nodeName)){var f=b.getAttribute("src");f&&(b.style.backgroundSize="100% 100%",b.style.backgroundImage="url("+f+")",b.removeAttribute("src"),b.addEventListener("load",e))}}},!1))});
/* lazysizes - parent-fit */
!function(a,b){var c=function(){b(a.lazySizes),a.removeEventListener("lazyunveilread",c,!0)};b=b.bind(null,a,a.document),"object"==typeof module&&module.exports?b(require("lazysizes")):a.lazySizes?c():a.addEventListener("lazyunveilread",c,!0)}(window,function(a,b,c){"use strict";if(a.addEventListener){var d=/\s+(\d+)(w|h)\s+(\d+)(w|h)/,e=/parent-fit["']*\s*:\s*["']*(contain|cover|width)/,f=/parent-container["']*\s*:\s*["']*(.+?)(?=(\s|$|,|'|"|;))/,g=/^picture$/i,h=function(a){return getComputedStyle(a,null)||{}},i={getParent:function(b,c){var d=b,e=b.parentNode;return c&&"prev"!=c||!e||!g.test(e.nodeName||"")||(e=e.parentNode),"self"!=c&&(d="prev"==c?b.previousElementSibling:c&&(e.closest||a.jQuery)?(e.closest?e.closest(c):jQuery(e).closest(c)[0])||e:e),d},getFit:function(a){var b,c,d=h(a),g=d.content||d.fontFamily,j={fit:a._lazysizesParentFit||a.getAttribute("data-parent-fit")};return!j.fit&&g&&(b=g.match(e))&&(j.fit=b[1]),j.fit?(c=a._lazysizesParentContainer||a.getAttribute("data-parent-container"),!c&&g&&(b=g.match(f))&&(c=b[1]),j.parent=i.getParent(a,c)):j.fit=d.objectFit,j},getImageRatio:function(b){var c,e,f,h,i=b.parentNode,j=i&&g.test(i.nodeName||"")?i.querySelectorAll("source, img"):[b];for(c=0;c<j.length;c++)if(b=j[c],e=b.getAttribute(lazySizesConfig.srcsetAttr)||b.getAttribute("srcset")||b.getAttribute("data-pfsrcset")||b.getAttribute("data-risrcset")||"",f=b._lsMedia||b.getAttribute("media"),f=lazySizesConfig.customMedia[b.getAttribute("data-media")||f]||f,e&&(!f||(a.matchMedia&&matchMedia(f)||{}).matches)){h=parseFloat(b.getAttribute("data-aspectratio")),!h&&e.match(d)&&(h="w"==RegExp.$2?RegExp.$1/RegExp.$3:RegExp.$3/RegExp.$1);break}return h},calculateSize:function(a,b){var c,d,e,f,g=this.getFit(a),h=g.fit,i=g.parent;return"width"==h||("contain"==h||"cover"==h)&&(e=this.getImageRatio(a))?(i?b=i.clientWidth:i=a,f=b,"width"==h?f=b:(d=i.clientHeight,d>40&&(c=b/d)&&("cover"==h&&e>c||"contain"==h&&c>e)&&(f=b*(e/c))),f):b}};c.parentFit=i,b.addEventListener("lazybeforesizes",function(a){if(!a.defaultPrevented&&a.detail.instance==c){var b=a.target;a.detail.width=i.calculateSize(b,a.detail.width)}})}});
/*! lazysizes - respimg */
!function(a,b){var c=function(){b(a.lazySizes),a.removeEventListener("lazyunveilread",c,!0)};b=b.bind(null,a,a.document),"object"==typeof module&&module.exports?b(require("lazysizes"),require("../fix-ios-sizes/fix-ios-sizes")):a.lazySizes?c():a.addEventListener("lazyunveilread",c,!0)}(window,function(a,b,c){"use strict";var d,e=c&&c.cfg||a.lazySizesConfig,f=b.createElement("img"),g="sizes"in f&&"srcset"in f,h=/\s+\d+h/g,i=function(){var a=/\s+(\d+)(w|h)\s+(\d+)(w|h)/,c=Array.prototype.forEach;return function(d){var e=b.createElement("img"),f=function(b){var c,d,e=b.getAttribute(lazySizesConfig.srcsetAttr);e&&((d=e.match(a))&&(c="w"==d[2]?d[1]/d[3]:d[3]/d[1],c&&b.setAttribute("data-aspectratio",c)),b.setAttribute(lazySizesConfig.srcsetAttr,e.replace(h,"")))},g=function(a){var b=a.target.parentNode;b&&"PICTURE"==b.nodeName&&c.call(b.getElementsByTagName("source"),f),f(a.target)},i=function(){e.currentSrc&&b.removeEventListener("lazybeforeunveil",g)};d[1]&&(b.addEventListener("lazybeforeunveil",g),e.onload=i,e.onerror=i,e.srcset="data:,a 1w 1h",e.complete&&i())}}();if(e||(e={},a.lazySizesConfig=e),e.supportsType||(e.supportsType=function(a){return!a}),!a.picturefill&&!e.pf){if(a.HTMLPictureElement&&g)return b.msElementsFromPoint&&i(navigator.userAgent.match(/Edge\/(\d+)/)),void(e.pf=function(){});e.pf=function(b){var c,e;if(!a.picturefill)for(c=0,e=b.elements.length;e>c;c++)d(b.elements[c])},d=function(){var f=function(a,b){return a.w-b.w},i=/^\s*\d+\.*\d*px\s*$/,j=function(a){var b,c,d=a.length,e=a[d-1],f=0;for(f;d>f;f++)if(e=a[f],e.d=e.w/a.w,e.d>=a.d){!e.cached&&(b=a[f-1])&&b.d>a.d-.13*Math.pow(a.d,2.2)&&(c=Math.pow(b.d-.6,1.6),b.cached&&(b.d+=.15*c),b.d+(e.d-a.d)*c>a.d&&(e=b));break}return e},k=function(){var a,b=/(([^,\s].[^\s]+)\s+(\d+)w)/g,c=/\s/,d=function(b,c,d,e){a.push({c:c,u:d,w:1*e})};return function(e){return a=[],e=e.trim(),e.replace(h,"").replace(b,d),a.length||!e||c.test(e)||a.push({c:e,u:e,w:99}),a}}(),l=function(){l.init||(l.init=!0,addEventListener("resize",function(){var a,c=b.getElementsByClassName("lazymatchmedia"),e=function(){var a,b;for(a=0,b=c.length;b>a;a++)d(c[a])};return function(){clearTimeout(a),a=setTimeout(e,66)}}()))},m=function(b,d){var f,g=b.getAttribute("srcset")||b.getAttribute(e.srcsetAttr);!g&&d&&(g=b._lazypolyfill?b._lazypolyfill._set:b.getAttribute(e.srcAttr)||b.getAttribute("src")),b._lazypolyfill&&b._lazypolyfill._set==g||(f=k(g||""),d&&b.parentNode&&(f.isPicture="PICTURE"==b.parentNode.nodeName.toUpperCase(),f.isPicture&&a.matchMedia&&(c.aC(b,"lazymatchmedia"),l())),f._set=g,Object.defineProperty(b,"_lazypolyfill",{value:f,writable:!0}))},n=function(b){var d=a.devicePixelRatio||1,e=c.getX&&c.getX(b);return Math.min(e||d,2.5,d)},o=function(b){return a.matchMedia?(o=function(a){return!a||(matchMedia(a)||{}).matches})(b):!b},p=function(a){var b,d,g,h,k,l,p;if(h=a,m(h,!0),k=h._lazypolyfill,k.isPicture)for(d=0,b=a.parentNode.getElementsByTagName("source"),g=b.length;g>d;d++)if(e.supportsType(b[d].getAttribute("type"),a)&&o(b[d].getAttribute("media"))){h=b[d],m(h),k=h._lazypolyfill;break}return k.length>1?(p=h.getAttribute("sizes")||"",p=i.test(p)&&parseInt(p,10)||c.gW(a,a.parentNode),k.d=n(a),!k.src||!k.w||k.w<p?(k.w=p,l=j(k.sort(f)),k.src=l):l=k.src):l=k[0],l},q=function(a){if(!g||!a.parentNode||"PICTURE"==a.parentNode.nodeName.toUpperCase()){var b=p(a);b&&b.u&&a._lazypolyfill.cur!=b.u&&(a._lazypolyfill.cur=b.u,b.cached=!0,a.setAttribute(e.srcAttr,b.u),a.setAttribute("src",b.u))}};return q.parse=k,q}(),e.loadedClass&&e.loadingClass&&!function(){var a=[];['img[sizes$="px"][srcset].',"picture > img:not([srcset])."].forEach(function(b){a.push(b+e.loadedClass),a.push(b+e.loadingClass)}),e.pf({elements:b.querySelectorAll(a.join(", "))})}()}});
/*! lazysizes - bgset */
!function(a,b){var c=function(){b(a.lazySizes),a.removeEventListener("lazyunveilread",c,!0)};b=b.bind(null,a,a.document),"object"==typeof module&&module.exports?b(require("lazysizes")):a.lazySizes?c():a.addEventListener("lazyunveilread",c,!0)}(window,function(a,b,c){"use strict";if(a.addEventListener){var d=/\s+/g,e=/\s*\|\s+|\s+\|\s*/g,f=/^(.+?)(?:\s+\[\s*(.+?)\s*\])?$/,g=/\(|\)|'/,h={contain:1,cover:1},i=function(a){var b=c.gW(a,a.parentNode);return(!a._lazysizesWidth||b>a._lazysizesWidth)&&(a._lazysizesWidth=b),a._lazysizesWidth},j=function(a){var b;return b=(getComputedStyle(a)||{getPropertyValue:function(){}}).getPropertyValue("background-size"),!h[b]&&h[a.style.backgroundSize]&&(b=a.style.backgroundSize),b},k=function(a,c,g){var h=b.createElement("picture"),i=c.getAttribute(lazySizesConfig.sizesAttr),j=c.getAttribute("data-ratio"),k=c.getAttribute("data-optimumx");c._lazybgset&&c._lazybgset.parentNode==c&&c.removeChild(c._lazybgset),Object.defineProperty(g,"_lazybgset",{value:c,writable:!0}),Object.defineProperty(c,"_lazybgset",{value:h,writable:!0}),a=a.replace(d," ").split(e),h.style.display="none",g.className=lazySizesConfig.lazyClass,1!=a.length||i||(i="auto"),a.forEach(function(a){var c=b.createElement("source");i&&"auto"!=i&&c.setAttribute("sizes",i),a.match(f)&&(c.setAttribute(lazySizesConfig.srcsetAttr,RegExp.$1),RegExp.$2&&c.setAttribute("media",lazySizesConfig.customMedia[RegExp.$2]||RegExp.$2)),h.appendChild(c)}),i&&(g.setAttribute(lazySizesConfig.sizesAttr,i),c.removeAttribute(lazySizesConfig.sizesAttr),c.removeAttribute("sizes")),k&&g.setAttribute("data-optimumx",k),j&&g.setAttribute("data-ratio",j),h.appendChild(g),c.appendChild(h)},l=function(a){if(a.target._lazybgset){var b=a.target,d=b._lazybgset,e=b.currentSrc||b.src;e&&(d.style.backgroundImage="url("+(g.test(e)?JSON.stringify(e):e)+")"),b._lazybgsetLoading&&(c.fire(d,"_lazyloaded",{},!1,!0),delete b._lazybgsetLoading)}};addEventListener("lazybeforeunveil",function(a){var d,e,f;!a.defaultPrevented&&(d=a.target.getAttribute("data-bgset"))&&(f=a.target,e=b.createElement("img"),e.alt="",e._lazybgsetLoading=!0,a.detail.firesLoad=!0,k(d,f,e),setTimeout(function(){c.loader.unveil(e),c.rAF(function(){c.fire(e,"_lazyloaded",{},!0,!0),e.complete&&l({target:e})})}))}),b.addEventListener("load",l,!0),a.addEventListener("lazybeforesizes",function(a){if(a.detail.instance==c&&a.target._lazybgset&&a.detail.dataAttr){var b=a.target._lazybgset,d=j(b);h[d]&&(a.target._lazysizesParentFit=d,c.rAF(function(){a.target.setAttribute("data-parent-fit",d),a.target._lazysizesParentFit&&delete a.target._lazysizesParentFit}))}},!0),b.documentElement.addEventListener("lazybeforesizes",function(a){!a.defaultPrevented&&a.target._lazybgset&&a.detail.instance==c&&(a.detail.width=i(a.target._lazybgset))})}});
/* lazysizes placeholder removal */
document.addEventListener('lazyloaded', function(e){
  e.target.parentElement.className = e.target.parentElement.className.replace('lazyload--placeholder', '');
});



const utilities = new function() {
	var _ = this;

	_.url = new function() {
		var __ = this;
		__.get_current = function() {
			return window.location.href;
		}
		__.get_clean = function() {
			return __.get_current().split(/[?#]/)[0];
		}
	}

	_.similarity = function(s1, s2) {
	  var longer = s1;
	  var shorter = s2;
	  if (s1.length < s2.length) {
	    longer = s2;
	    shorter = s1;
	  }
	  var longerLength = longer.length;
	  if (longerLength == 0) {
	    return 1.0;
	  }
	  return (longerLength - _.editDistance(longer, shorter)) / parseFloat(longerLength);
	}

	_.editDistance = function(s1, s2) {
	  s1 = s1.toLowerCase();
	  s2 = s2.toLowerCase();

	  var costs = new Array();
	  for (var i = 0; i <= s1.length; i++) {
	    var lastValue = i;
	    for (var j = 0; j <= s2.length; j++) {
	      if (i == 0)
	        costs[j] = j;
	      else {
	        if (j > 0) {
	          var newValue = costs[j - 1];
	          if (s1.charAt(i - 1) != s2.charAt(j - 1))
	            newValue = Math.min(Math.min(newValue, lastValue),
	              costs[j]) + 1;
	          costs[j - 1] = lastValue;
	          lastValue = newValue;
	        }
	      }
	    }
	    if (i > 0)
	      costs[s2.length] = lastValue;
	  }
	  return costs[s2.length];
	}

	_.handelise = function(text) {
	  return text.toLowerCase().replace(/&nbsp;/g, " ").replace(/\s/g, '-').replace(/[^\w-]/gi, '');
	}

}






const raf = window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.msRequestAnimationFrame || window.oRequestAnimationFrame;

window.screenEvents = new function() {
	const _ = this;

	_.$window = $(window);
	_.lastScrollTop = _.$window.scrollTop();
	_.anim_elig_height = _.$window.height()/1.5;
	_.lastWindowWidth = _.$window.innerWidth();
	_.windowHeight = _.$window.innerHeight();
	_.hasProductGallery = $("#pp-gallery").length>0?true:false;
	_.lastProductGalleryScroll = 0;

	_.nearest_title = "";
	_.nearest_offish = 10000;

	_.hasBuyBox = $("#pp-product-form").length>0?true:false;
	if(_.hasBuyBox) {
	  _.buyBoxTop = $("#pp-product-form").offset().top;
	  _.buyBoxHeight = $("#pp-product-form").height();
	}

	_.init = function() {
		if(raf) _.loop();
	  _.detect_onscreen();
	}


	//Performant onscroll - credit https://joji.me/en-us/blog/how-to-develop-high-performance-onscroll-event/
	_.detect_onscreen = function () {
		var __ = this;
		__.classes = {
			animateable: {
				selector: ".can-animate:not(.animated)",
				class: "animated"
			},
			swappable: {
				selector: ".swappable-image",
				class: "swapped"
			}
		};
	  $(__.classes.animateable.selector).each(function(){
	    if($(this).offset().top<_.lastScrollTop+_.anim_elig_height) $(this).addClass(__.classes.animateable.class);
	  });
	  $(__.classes.swappable.selector).each(function(){
	    $(this).toggleClass(__.classes.swappable.class,$(this).offset().top<(_.lastScrollTop+(_.anim_elig_height/2)));
	  });
	};

	_.detect_closest_title = function() {
	  if($("body.template-product,body.template-page").length==1){
	    var new_nearest_title = "";
	    var nearest_offish = 10000;
	    if(window.scrollY>window.innerHeight/2) {
	      $("#min-range .shopify-section:not(:first-child) section").find(".container--width>h2,.twin-content>h2,.product-content--content>h2,.ingredients--title,.container--width>h3,.section-intro>h2,.featured-ingredient--text>h2").each(function(){
	        offish = Math.abs($(this).offset().top-window.scrollY);
	        if(offish<nearest_offish) {
	          // Directory entries carry their metaobject handle as an id; titles can repeat
	          var $ingredient = $(this).closest(".featured-ingredient[id]");
	          new_nearest_title = $ingredient.length ? $ingredient.attr("id") : utilities.handelise($(this).text());
	          nearest_offish = offish;
	        }
	      });
	      if(new_nearest_title!=_.nearest_title&&new_nearest_title!="") {
	        _.nearest_title = new_nearest_title;
	        const stateObj = { title: 'page' };
	        history.replaceState(stateObj, '', utilities.url.get_clean()+window.location.search+"#"+_.nearest_title);
	      }
	    } else {
	      _.nearest_title = "";
        const stateObj = { title: 'page' };
	      history.replaceState(stateObj, '', window.location.pathname+window.location.search);
	    }
	  }
	}

	_.loop = function() {
	  var scrollTop = _.$window.scrollTop();
	  var windowWidth = _.$window.innerWidth();
	  if(_.lastScrollTop===scrollTop&&windowWidth===_.lastWindowWidth) {
	  } else {
	    if(_.lastScrollTop!=scrollTop) {
	      _.lastScrollTop = scrollTop;
	      _.detect_onscreen();
	      _.detect_closest_title();
	    }
	    if(windowWidth!=_.lastWindowWidth) {
	      if(window.accounts!=undefined) window.accounts.components.component_action.check_menu_state();
	      if(windowWidth<501&&main.hasOwnProperty("productPage")&&main.productPage.hasOwnProperty("gallery")) { main.productPage.gallery.destroy(); }
	      _.lastWindowWidth = windowWidth;
	    }
	  }
	  
	  if((windowWidth<640&&scrollTop>120)||(windowWidth>639&&scrollTop>140)) {
	    $('body').addClass("offset-top");
	  } else if(scrollTop<50) {
	    $('body').removeClass("offset-top");
	  }
	  if((windowWidth<480&&scrollTop>2400)) {
	    $('body').addClass("deep-scroll");
	  } else {
	    $('body').removeClass("deep-scroll");
	  }
	  if(_.hasBuyBox&&scrollTop+_.windowHeight>=(_.buyBoxTop+100)&&scrollTop<=_.buyBoxTop+_.buyBoxHeight-150){
	    $('body').addClass("buy-box--visible");
	  } else {
	    $('body').removeClass("buy-box--visible");
	  }
	  if(_.hasProductGallery&&$(".mobile-gallery--master").scrollLeft()!=_.lastProductGalleryScroll){
	    $(".mobile-gallery--picker .active").removeClass("active");
	    $(".mobile-gallery--picker .mobile-gallery--thumbnail").eq(parseInt($(".mobile-gallery--master").scrollLeft()/$(".mobile-gallery--image").eq(0).width())).addClass("active");
	    _.lastProductGalleryScroll = $(".mobile-gallery--master").scrollLeft();
	  }
	  
	  raf(_.loop);

	}
}

$(function() {
	screenEvents.init();
});


























window.main = new Object();
main.jQuery = jQuery;

//In-page term definitions
(function($) {
	var $ = jQuery = $;

	main.afterFlex = new function() {
	  var _ = this;

	  _.class = "afterFlex";

	  //Initialisation
	  _.init = function() {
	  	_.createEventHandlers();
        _.terms = _.captureDictionary("key");
        _.definitions = _.captureDictionary("value");
        _.install();
	  	_.acknowledge("initialisation complete");
	  }

	  _.createEventHandlers = function() {
        $('body').on('click','[data-page-action]',function(e){
          var $element = $(e.currentTarget);
          _.page_action[$element.data('page-action')]($element);
          return false;
        });
	  }

      _.page_action = new function() {
        var __ = this;
        __.show_activation_popup = function($element) {
          $("#AAI-buttontext a").trigger("click");
        }
        __.show_detail = function($element) {
          $element.closest("div").find(".info-detail").slideToggle(150);
        }
        __.slider_prev = function($element) {
          var $wrapper = $element.closest(".has-collection-browser--menu");
          var $menu = $wrapper.find(".collection-browser--menu");
          $menu.find(".active").closest("li").prev("li").find("a").trigger("click");
          __.slider_status($wrapper);
        }
        __.slider_next = function($element) {
          var $wrapper = $element.closest(".has-collection-browser--menu");
          var $menu = $wrapper.find(".collection-browser--menu");
          $menu.find(".active").closest("li").next("li").find("a").trigger("click");
          __.slider_status($wrapper);
        }
        __.slider_status = function($wrapper) {
          var $menu = $wrapper.find(".collection-browser--menu");
          var index = $menu.find(".active").closest("li").index();
          var count = $menu.find("li").length;
          if(index==0) {
            $wrapper.find(".collection-browser--nav--prev").addClass("collection-browser--nav--disabled");
          } else {
            $wrapper.find(".collection-browser--nav--prev").removeClass("collection-browser--nav--disabled");
          }
          if(index==count-1) {
            $wrapper.find(".collection-browser--nav--next").addClass("collection-browser--nav--disabled");
          } else {
            $wrapper.find(".collection-browser--nav--next").removeClass("collection-browser--nav--disabled");
          }
          var menu_width = $(".has-collection-browser--menu").width();
          var left_position = $menu.scrollLeft();
          var select_position = $menu.find(".active").offset().left;
          var select_width = $menu.find(".active").width();
            var adjustment = (select_position+left_position)-(menu_width/2)+(select_width/2)-10;
            if(adjustment<0) adjustment = 0;
          $menu.animate({"scrollLeft":(adjustment)},150);
        }
        __.switch_menu_pane = function($element) {
          $(".main-submenu [data-menu-pane]").addClass("hidden");
          $(".main-submenu [data-menu-pane='"+$element.data("linked-pane")+"']").removeClass("hidden");
          $("[data-page-action='switch_menu_pane']").removeClass("active");
          $element.addClass("active");
        }
        __.mute = function($element) {
          //Silent fail
        }
        __.submit_form = function($element) {
          $element.closest("form").submit();
        }
        __.read_more = function($element) {
          $element.closest(".rte").find(".hidden").fadeIn();
          $element.closest("p").hide();
        }
        __.expand_content = function($element) {
          $element.toggleClass("open");
          $element.next(".rte").slideToggle(100);
        }
        
        
      }

	  _.install = function() {
        $('.rte').each(function(){
          var input, re;
          for(i=0;i<_.terms.length;i++) {
            input = $(this).html();
            re = new RegExp(_.terms[i],"g");
            $(this).html(input.replace(re, "<span class='has-term-definition'>"+_.terms[i]+"<span class='term-definition'><span class='h5'>"+_.terms[i]+"</span>"+_.definitions[i]+"</span></span>"));
          }
        });
	  }
      
      _.captureDictionary = function(type) {
        var result = [];
        $('#dictionary-definitions tr').each(function(){
          result.push($(this).find('td:nth-child('+(type=="key"?"1":"2")+')').html());
        });
        return result;
      }

	  //System level operations
	  _.acknowledge = function(message) {
	  }
	}

	$(function(){ main.afterFlex.init(); });

})(main.jQuery);

//Sidebar cart functionality (add to cart, etc)
(function($) {
	var $ = jQuery = $;

	main.sidebarCart = new function() {
	  var _ = this;

	  _.class = "sidebarCart";
      _.cart_update_working = false;

	  //Initialisation
	  _.init = function() {
	  	_.createEventHandlers();
        const params = new Proxy(new URLSearchParams(window.location.search), {
          get: (searchParams, prop) => searchParams.get(prop),
        });
        if(params.cart=="true") _.cart_action.cart_open(undefined);
	  	_.acknowledge("initialisation complete");
	  }

	  _.createEventHandlers = function() {
        $('body').on('click','#cart-sidebar-wrapper #continue,.cart-screen',function(e){
          $('body').removeClass('cart-open');
          return false;
        }).on('click','[data-cart-action]',function(e){
          var $element = $(e.currentTarget);
          _.cart_action[$element.data('cart-action')]($element);
          if($element.data('cart-action')!="switch_type") return false;
        }).on('click','#AddToCart,.AddToCart',function(e){
          var $element = $(e.currentTarget);
          _.add_to_cart($element);
          return false;
        }).on('click','#cart-sidebar-wrapper .cart-item--remove,#cart-sidebar-wrapper .cart-item--increase,#cart-sidebar-wrapper .cart-item--decrease',function(e){
          var $element = $(e.currentTarget);
          _.change_quantity($element);
          return false;
        }).on('submit','.shopify-product-form',function(e){
          var $element = $(e.currentTarget);
          $element = $element.find('[type="submit"]');
          _.add_to_cart($element);
          e.preventDefault();
          return false;
        });
	  }
      
      _.cart_action = new function() {
        var __ = this;
        __.cart_open = function($element) {
          $('body').addClass('cart-open');
        }
        __.upgrade_invite = function($element) {
          $element.hide();
          $element.next(".upgrade_action").show();
        }
        __.upgrade_product = function($element) {
          var $card = $element.closest('.card');
          var $form = $card.find(".pseudo-form");
          $card.addClass('upgrading');
          var form_data = {
            "id":$form.find("[name='id']").val(),
            "quantity":$form.find("[data-upgrade-quantity]").attr("data-upgrade-quantity"),
            "selling_plan":$form.find("[name='selling_plan']").val()
          };
          $.get($card.find(".cart-item--remove").attr("href"),function(data){
            $.post($form.attr("action"),form_data,function(e){
	          _.update(true);
            });
          });
        }
        __.buy_reward = function($element) {
          $element.addClass("working");
          var $instant_buy = $(".instant-buy-button[data-product-handle='"+$element.closest("[data-product-handle]").data("product-handle")+"']").find("button");
          $instant_buy.trigger("click");
        }
        __.switch_type = function($element) {
          var $form = $element.closest(".pseudo-form");
          $form.find("[type='radio']").prop("checked",false);
          $form.find("[type='radio']").removeAttr("checked");
          $element.prop("checked",true);
          $form.find(".btn").text($element.data("price")+" | Add to basket");
          $form.find(".has-quantity .micro_select").toggle($element.data("type")!="once");
        }
        __.pseudo_form_add = function($element) {
          var $form = $element.closest(".pseudo-form");
          var t_data = {};
          $form.find("input,select").each(function(){
            if(($(this).attr("type")!="radio"||$(this).is(":checked"))&&($form.find("[data-type='subscription']").is(":checked")||$(this).attr("data-name").indexOf("selling_plan")<0)) t_data[$(this).data("name")] = $(this).val();
          });
          $element.addClass('cart-add--working');
          $.post($form.attr('action'),t_data,function(e){
            _.update(true);
          });
        }
      }
      
      _.add_to_cart = function($element) {
        //AJAX Add to Cart
        var $form = $element.closest('form');
        var $button = $element;
        //Remove all recharge injections
        $form.find(".rc-container-wrapper").remove();
        $button.addClass('cart-add--working');
        var data_string = "id="+$form.find("[name='id']").val()+"&quantity="+$form.find("[name='quantity']").val();//+"&properties[pre-order]=true";
        $.post($form.attr('action'),$form.serialize(),function(e){
          _.update(true);
          $button.removeClass('cart-add--working');
          if($(".gPreorderCountdownWrapper").length>0) {
            $('#preOrderModal .modal_window').find("form").remove();
            $('#preOrderModal').css({'display':'none'});
          }
          if(account_main) account_main.clearAllCarets();
          $("#preOrderModal").hide();
        });
      }
      
      _.change_quantity = function($element) {
        if(!_.cart_update_working) {
          $element.addClass('cart-item--working');
          $.get($element.attr('href'),function(e){
            _.update(false);
          });
          _.cart_update_working = true;
        }
      }

      _.update = function(open=false) {
        $.ajax({
          url: '/?view=cart',
          type: 'get',
          dataType: "text",
          success: function(data) {
            var $rdata = $(data).find('#recharge_scripts');
            var $data = $(data).find('#cart-sidebar-wrapper');
            $('#cart-sidebar-inner').html($data.find('#cart-sidebar-inner').html());
            var products_in_cart = 0;
            $('#cart-sidebar-inner .cart-contents--item').each(function(){
              products_in_cart += parseInt($(this).find(".cart-item--quantity").text());
            });
            $('#recharge_scripts').html($rdata.html());
            if(open) $('body').addClass('cart-open');
            $('#LinkSubcartSection').text("Basket ("+$('#sidebar-cart--total').text()+")");
            _.cart_update_working = false;
            if(products_in_cart>0) make_recommendations();
            if(products_in_cart>0) {
              $(".head-wrapper .links-icons .cart").addClass("has-items");
              if($(".head-wrapper .links-icons .cart span").length==0) $(".head-wrapper .links-icons .cart").append($("<span></span>"));
              $(".head-wrapper .links-icons .cart span").text(products_in_cart);
              $(".headless-triptych .has-cart .cart span").text(products_in_cart);
            } else {
              $(".head-wrapper .links-icons .cart").addClass("has-items");
              $(".head-wrapper .links-icons .cart span").remove();
            }
            $('body').find('#cart-recommendations').find(".trustpilot-widget").each(function(){
              window.Trustpilot.loadFromElement($(this)[0]);
            })
          }
        });
	  }
      
	  //System level operations
	  _.acknowledge = function(message) {
	  }
	}

	$(function(){ main.sidebarCart.init(); });

})(main.jQuery);


//AB Test functionality (product page promo)
(function($) {
	var $ = jQuery = $;

	main.splitTest = new function() {
	  var _ = this;

	  _.class = "splitTest";
      _.cart_update_working = false;

	  //Initialisation
	  _.init = function() {
	  	_.createEventHandlers();
        if(!_.assignment.check()) {
          _.assignment.lookup(); //Calls assign if failed
        } else {
          _.assignment.verified();
          _.assignment.translate();
          _.test.init();
        }
	  	_.acknowledge("initialisation complete");
	  }

	  _.createEventHandlers = function() {
        $('body').on('click','[data-split-test-action]',function(e){
          var $element = $(e.currentTarget);
          _.acknowledge("Request to call "+$element.data('split-test-action'));
          _.action[$element.data('split-test-action')]($element);
        });
	  }

      _.assignment = new function() {
        var __ = this;
        __.check = function() {
          return getCookie("ab_1552")==""?false:true;
        }
        __.verified = function() {
          var verification = getCookie("ab_1552_verified");
          if(!verification) {
            if(sessionStorage.hasOwnProperty("account_data")) {
              var j_data = JSON.parse(sessionStorage.account_data);
              var t_data = {
                prekey:getCookie("ab_1552_prekey"),
                local_id:j_data.local_id,
                remote_id:j_data.hasOwnProperty("remote_id")?j_data.remote_id:false
              }
              $.post("https://accounts.togetherhealth.co.uk/testing/verify/",t_data,function(data){
                if(data=="verified") setCookie("ab_1552_verified","1",90);
              });
            }
          }
        }
        __.translate = function() {
        }
        __.lookup = function() {
          if(typeof(customer_id)!=="undefined") {
            $.get("https://accounts.togetherhealth.co.uk/testing/"+customer_id+"/fetch/",function(data){
              var j_data = JSON.parse(data);
              if(j_data.hasOwnProperty("prekey")) {
                setCookie("ab_1552",j_data.assignment,90);
                setCookie("ab_1552_prekey",j_data.prekey,90);
                _.test.init();
              } else {
                __.assign();
              }
            });
          } else {
            __.assign();
          }
        }
        __.assign = function() {
          var amount = parseInt(Math.random()*1000);
          if(parseInt(amount/2)*2==amount) {
            setCookie("ab_1552","a",90);
          } else {
            setCookie("ab_1552","b",90);
          }
          setCookie("ab_7933",getCookie("ab_1552"),90);
          setCookie("ab_1552_prekey",__.create_key(),90);
          __.store();
          __.translate();
          _.test.init();
        }
        __.create_key = function() {
          var pool = "1234567890abcdef";
          var tkey = "";
          for(var i=0;i<32;i++) tkey += pool.substr(parseInt(Math.random()*pool.length),1);
          return tkey;
        }
        __.store = function() {
          var t_data = {
            assignment:getCookie("ab_1552"),
            prekey:getCookie("ab_1552_prekey")
          }
          if(sessionStorage.hasOwnProperty("account_data")) {
            var j_data = JSON.parse(sessionStorage.account_data);
            t_data.local_id = j_data.local_id;
            t_data.remote_id = j_data.hasOwnProperty("remote_id")?j_data.remote_id:false;
          } else {
            t_data.local_id = "";
            t_data.remote_id = "";
          }
          $.post("https://accounts.togetherhealth.co.uk/testing/create/",t_data,function(data){
            var j_data = JSON.parse(data);
            if(j_data.hasOwnProperty("prekey")) { // Function returned extant data, so align local store
              setCookie("ab_1552",j_data.assignment,90);
              setCookie("ab_1552_prekey",j_data.prekey,90);
            }
            if(j_data.hasOwnProperty("local_id")&&j_data.hasOwnProperty("remote_id")) setCookie("ab_1552_verified","1",90);
            setCookie("ab_7933",getCookie("ab_1552"),90);
          });
        }
      }

      _.test = new function() {
        var __ = this;
        __.init = function() {
          setCookie("ab_7933",getCookie("ab_1552"),90);
          var assignment = getCookie("ab_7933");
          const params = new Proxy(new URLSearchParams(window.location.search), {
            get: (searchParams, prop) => searchParams.get(prop),
          });
          if(params.ab_7933) assignment = params.ab_7933;
          if(assignment=="b") {

            //Reincluded (from ab-assets) to apply if assignment is after first visit to site (ie user lands on product page)
            if(typeof(done_7933)!=="undefined"&&done_7933==false) {
              var estyle = document.createElement("link");
              estyle.setAttribute("type","text/css")
              estyle.setAttribute("rel","stylesheet");
              estyle.setAttribute("href",estyle_href);
              document.querySelector("head").appendChild(estyle);

              if($("body.template-product").length>0) {
                var $script = $("<script src='"+pp_path+"' defer />");
                $('head').append($script);
              }

              done_7933 = true;

            }
            
          }
          
        }
      }
      
      _.action = new function() {
        var __ = this;
        __.claim = function($element) {
          $element.text("Claimed!");
          $element.addClass("claimed");
          setCookie("ab_1552_claimed","1",90);
          $("#ab_1552_promobox_banner").slideDown();
          var j_data = false;
          if(sessionStorage.hasOwnProperty("account_data")) j_data = JSON.parse(sessionStorage.account_data);
          var t_data = {
            prekey:getCookie("ab_1552_prekey"),
            local_id:j_data?j_data.local_id:false,
            remote_id:j_data.hasOwnProperty("remote_id")?j_data.remote_id:false,
            action:"claim"
          }
          $.post("https://accounts.togetherhealth.co.uk/testing/event/",t_data);
        }
      }
      
	  //System level operations
	  _.acknowledge = function(message) {
	  }
	}

	$(function(){ main.splitTest.init(); });

})(main.jQuery);

//CART cart ("pageCart") functionality (manage product type, etc)
(function($) {
	var $ = jQuery = $;

	main.pageCart = new function() {
	  var _ = this;

	  _.class = "pageCart";
      _.cart_update_working = false;

	  //Initialisation
	  _.init = function() {
	  	_.createEventHandlers();
	  	_.acknowledge("initialisation complete");
	  }

	  _.createEventHandlers = function() {
        $('body').on('click','[data-pagecart-action]',function(e){
          var $element = $(e.currentTarget);
          _.pagecart_action[$element.data('pagecart-action')]($element);
          if($element.data('pagecart-action')!="switch_type") return false;
        });
	  }
      
      _.pagecart_action = new function() {
        var __ = this;
        
        __.switch_type = function($element) {
          var $form = $element.closest("form");
          if($element.data("type")=="once") {
            //Destroy extra fields
            $form.find("[subscription-name]").attr("name","");
          } else {
            //Restore extra fields
            $form.find("[subscription-name]").each(function(){
              $(this).attr("name",$(this).attr("subscription-name"));
            });
          }
          $form.find("[type='submit']").attr("value",$element.data("price")+" | Add to basket");
        }
        
        //Hangovers
        __.upgrade_invite = function($element) {
          $element.hide();
          $element.next(".upgrade_action").show();
        }
        __.upgrade_product = function($element) {
          var $card = $element.closest('.card');
          var $form = $card.find(".pseudo-form");
          $card.addClass('upgrading');
          var form_data = {
            "id":$form.find("[name='id']").val(),
            "quantity":$form.find("[data-upgrade-quantity]").attr("data-upgrade-quantity"),
            "selling_plan":$form.find("[name='selling_plan']").val()
          };
          $.get($card.find(".cart-button--remove").attr("href"),function(data){
            $.post($form.attr("action"),form_data,function(e){
	          _.update(true);
            });
          });
        }
      }

      _.update = function(open=false) {
        window.location.href = "/cart";
	  }
      
	  //System level operations
	  _.acknowledge = function(message) {
	  }
	}

	$(function(){ main.pageCart.init(); });

})(main.jQuery);


//Select reviews actions
(function($) {
	var $ = jQuery = $;

	main.selectReviews = new function() {
	  var _ = this;

	  _.class = "selectReviews";

	  //Initialisation
	  _.init = function() {
	  	_.createEventHandlers();
	  	_.acknowledge("initialisation complete");
	  }

	  _.createEventHandlers = function() {
        $('body').on('click','[data-selectreviews-action]',function(e){
          var $element = $(e.currentTarget);
          _.reviews_action[$element.attr('data-selectreviews-action')]($element);
          if($element.attr('data-reviews-action')!="switch_type") return false;
        });
	  }
      
      _.reviews_action = new function() {
        var __ = this;
        __.show_reviews_tab = function($element) {
          $element.closest(".bestreviews--tabs").find(".active").removeClass("active");
          $element.addClass("active");
          $("[data-reviews-content]").hide();
          $(".bestreviews--contents [data-reviews-content='"+$element.data("reviews-tab")+"']").show();
        }
        __.show_reviews_mobile_tab = function($element) {
          $element.toggleClass("active");
          $element.next(".bestreviews--mobile--content").slideToggle(150);
          $("html,body").animate({scrollTop:$element.offset().top-130});
        }
      }

	  //System level operations
	  _.acknowledge = function(message) {
	  }
	}

	$(function(){ main.selectReviews.init(); });

})(main.jQuery);


//Product page functionality, inc adding to subscription
(function($) {
	var $ = jQuery = $;

	main.productPage = new function() {
	  var _ = this;

	  _.class = "productPage";
      _.checked_subs = false;
      _.account_data = [];

	  //Initialisation
	  _.init = function() {
	  	_.createEventHandlers();
        //Handelise all sections
        if($("body.template-product,body.template-page").length>0) {
          $("#min-range .shopify-section:not(:first-child)").each(function(){
            $(this).find(".container--width>h2,.twin-content>h2,.product-section--wrapper--even .product-content--content>h2,.ingredients--title,.container--width>h3").each(function(){
              var handle = utilities.handelise($(this).text());
              if(handle=="naturally-effective-ingredients") handle = "ingredients";
              $(this).closest("section").attr("id",handle);
            });
          });
        }
        
    	if($("body").hasClass("template-product")) {
          //Link ingredients
          if($(".new-ingredients-wrapper").length==2) {
            $(".new-ingredients-wrapper").eq(1).attr("id","full-ingredients");
            var $link = $($("#ingredients_link_forward").html());
            $(".new-ingredients-wrapper").eq(0).find(".breakout--width").append($link);
          }
          if($(".naturally-effective-ingredients").length==1&&$(".new-ingredients-wrapper").length==1) {
            $(".new-ingredients-wrapper").eq(0).attr("id","full-ingredients");
            var $link = $($("#ingredients_link_forward").html());
            $(".naturally-effective-ingredients").eq(0).find(".breakout--width").append($link);
          }
        }
        
        //Relocate product navigation dock
        if($('.product-navigation--dock').length==1) $('.product-navigation--dock').before($('.product-navigation--dock + .promo-strip'));
        if($('.page-holder[data-page]').length>0) {
          $('.page-holder[data-page]').each(function(){
            var $title = $("<div class='page-holder-title' />");
            $title.attr('data-page',$(this).data('page'));
            $title.append($(this).find('td:first-child h4'));
            $(this).before($title);
          });
        }
        if($("[data-product-action='show_latest_batch_global']").length>0&&$('[name="product_id"]').length==0) {
          $.get("https://accounts.togetherhealth.co.uk/batch/globallatest/",function(data){
            var j_data = JSON.parse(data);
            if(j_data.products.length) {
              var product = j_data.products[0];
              $("[data-product-action='show_latest_batch_global']").attr("href","https://accounts.togetherhealth.co.uk/batch_reports/"+product.filename).attr("target","_blank").removeAttr("data-product-action");
            }
          });
        }
        //Check current user (if any) has active subs
        if($(".product-form--subscription-option div .subs-privilege").length>0) setTimeout(function(){_.check_customer_has_subs()},100);
	  	_.acknowledge("initialisation complete");
        if(window.location.href.indexOf("#")>0&&$("body#account").length==0) {
          var starter_id = window.location.href.split("#")[1];
          if($("#"+starter_id).length>0){
            $("body,html").scrollTop($("#"+starter_id).offset().top-100);
          } else {
          }
        }
        //Preset 'latest batch' links as direct href attributes (avoids JS open window call)
        _.product_action.preset_latest_batch();
        
	  }

	  _.createEventHandlers = function() {
        $('body').on('click','[data-product-action]',function(e){
          var $element = $(e.currentTarget);
          _.product_action[$element.data('product-action')]($element);
          return false;
        }).on('change blur','[data-product-change-action]',function(e){
          var $element = $(e.currentTarget);
          _.product_action[$element.data('product-change-action')]($element);
          return false;
        }).on('click','[data-block-action]',function(e){
          e.preventDefault();
          return false;
        });
	  }

      _.check_customer_has_subs = function() {
        if(_.checked_subs===false) {
          if(window.sessionStorage.hasOwnProperty("account_data")){
            var j_data = JSON.parse(window.sessionStorage.account_data);
            if(!j_data.hasOwnProperty("my_subscriptions")||j_data.my_subscriptions.hasOwnProperty("error")||j_data.my_subscriptions.dates.length==0) {
              $(".product-form--subscription-option div .subs-privilege").remove();
            }
            _.checked_subs = true
          } else {
            //Retry
            setTimeout(function(){_.check_customer_has_subs()},100);
          }
        }
      }
      
      _.product_action = new function() {
        var __ = this;
        __.set_quantity = function($element) {
          var $quantity = $element.closest('.select-style').prev('input');
          $quantity.val($element.val());
          if($element.val()=="20") {
            $element.attr("name","");
            $element.closest('.select-style').hide();
            $quantity.attr("name","quantity");
            $quantity.show();
          }
          
          $wrapper = $element.closest("[data-unit-price]");
          var unit_price = $wrapper.data("unit-price");
          var quantity = $quantity.val();
          $wrapper.find('.order-total-price').html(Shopify.formatMoney(unit_price*quantity));
        }
        __.higher_quantity = function($element) {
          $wrapper = $element.closest("[data-unit-price]");
          var unit_price = $wrapper.data("unit-price");
          var quantity = $element.val();
          $wrapper.find('.order-total-price').html(Shopify.formatMoney(unit_price*quantity));
        }
        __.add_to_subscription = function($element) {
          var $title = "";
          var $content = $("<p class='working-wrapper'><span class='working'></span> Please wait while we fetch your subscriptions data ...</p>");
          accounts.components.window.setContent($title,$content);
          accounts.components.window.launch();
          if(!accounts.data.exists()) {
              accounts.data.retrieve(_.product_action,"check_for_subscription_data");
          } else {
            _.product_action.check_for_subscription_data($element);
          }
        }
        __.check_for_subscription_data = function($element) {
          if(!accounts.my_subscriptions.data.exists()) {
            accounts.my_subscriptions.data.retrieve(_.product_action,"ready_for_select_add_to_subscription");
          } else {
            accounts.components.window.close();
            _.product_action.select_add_to_subscription($element);
          }
        }
        __.ready_for_select_add_to_subscription = function($element) {
          _.account_data = JSON.parse(sessionStorage.getItem('account_data'));
          accounts.components.window.close();
          _.product_action.select_add_to_subscription($element);
        }
        __.select_add_to_subscription = function($element) {
          _.account_data = JSON.parse(sessionStorage.getItem('account_data'));
          var $title = $("<h3>Add product to existing subscription</h3>");
          var $content = $("<div class='custom-fieldset' />");
          $content.append("<p>This option allows you to skip checkout and add the product directly to an existing subscription</p>");
          $content.append("<p>You will not be charged until your next subscription is processed</p>");
          var $subscriptions_list = $("<p><b>Select subscription:</b> <span class='select-style'><select id='extend_subscription' /></span></p>");
          for(s=0;s<_.account_data.my_subscriptions.dates.length;s++) {
            var subscription = _.account_data.my_subscriptions.dates[s];
            $subscriptions_list.find("select").append("<option value='"+s+"'>"+accounts.sensibleDate(subscription.date)+" ("+subscription.line_items.length+" item"+(subscription.line_items.length==1?"":"s")+" shipped every "+subscription.line_items[0].order_interval_frequency+" "+subscription.line_items[0].order_interval_unit+"s)</option>");
          }
          $content.append($subscriptions_list);

          var $buttonBlock = $("<div class='account-page--window-buttons' />");
          var buttons = {
            "buttons": [
              {
                class: "account-page--button-secondary",
                action_handle: "data-component-action",
                action: "window_close",
                label: "Cancel"
              },
              {
                class: "account-page--button-primary",
                action_handle: "data-product-action",
                action: "add_product",
                label: "Add to selected subscription"
              }
            ]
          };
          $buttonBlock.append(accounts.components.buttonSet(buttons));
          $content.append($("<p class='error hidden'>Please select a subscription before proceeding!</p>"));
          $content.append($buttonBlock);
          accounts.components.window.setContent($title,$content);
          accounts.components.window.launch();
        }
        __.add_product = function($element) {
          $('.account-page--window-holder .account-page--button-primary').addClass("account-page--button-working");
          var subscription = _.account_data.my_subscriptions.dates[$('#extend_subscription').val()];
          var product_list = [];
          var product_titles = [];
          product_list.push($('#option-subscription [name="id"]').val());
          product_titles.push($('.product_title h1 b').eq(0).text());
          var new_subscriptions = {
            "variants":product_list,
            "titles":product_titles,
            "address_id":subscription.address_id,
            "next_charge_scheduled_at":subscription.date,
            "quantity":$("#charge_quantity").val(),
            "order_interval_unit":subscription.line_items[0].order_interval_unit,
            "order_interval_frequency":subscription.line_items[0].order_interval_frequency,
            "charge_interval_frequency":subscription.line_items[0].charge_interval_frequency
          };
          accountsRequest("thps/createSubscriptions/",{},new_subscriptions).done(function(data){
            //Mark data as stale
            _.account_data = JSON.parse(sessionStorage.getItem('account_data'));
            _.account_data.stale = true;
            sessionStorage.setItem('account_data',JSON.stringify(_.account_data));
            
          accounts.data.purge();
          window.accounts.data.retrieve();

            accounts.components.window.close();
            var $title = $("<h3>Add product to existing subscription</h3>");
            var $content = $("<div />");
            $content.append("<h2>Thank you!</h2>");
            $content.append("<p>"+$('.product_title h1 b').eq(0).text()+" will be included in your selected delivery</p>");
            $content.append("<p>Check your account page at any time if you need to update your subscriptions</p>");
            var $buttonBlock = $("<div class='account-page--window-buttons' />");
            var buttons = {
              "buttons": [
                {
                  class: "data-product-action",
                  action_handle: "data-component-action",
                  action: "window_close",
                  label: "Close"
                }
              ]
            };
            $buttonBlock.append(accounts.components.buttonSet(buttons));
            $content.append($buttonBlock);
            accounts.components.window.setContent($title,$content);
            accounts.components.window.launch();
          });
          
        }
        __.show_image = function($element) {
          var $title = "";
          var $content = $("<div class='lightbox_size_limit' data-product-action='uncap_image_size' />");
          var $image = $($element.html());
          $content.append($image);
          var $buttonBlock = $("<div class='account-page--window-buttons' />");
          var buttons = {
            "buttons": [
              {
                class: "account-page--button-secondary",
                action_handle: "data-component-action",
                action: "window_close",
                label: "Close"
              }
            ]
          };
          $buttonBlock.append(accounts.components.buttonSet(buttons));
          $content.append($buttonBlock);
          accounts.components.window.setContent($title,$content);
          accounts.components.window.launch();                    
        }
        __.show_image_gallery = function($element) {
          _.gallery.init(1,$element);
        }
        __.uncap_image_size = function($element) {
          $element.removeClass('lightbox_size_limit');
        }
        __.scroll_navigation = function($element) {
          $element.find('ul').animate({"scrollLeft":200});
          $element.addClass("scrolled");
        }
        
        __.show_latest_batch_global = function($element) {
          var $container = $("#batch_output");
          $container.html("");
          $element.addClass("working");
          $.get("https://accounts.togetherhealth.co.uk/batch/globallatest/",function(data){
            var j_data = JSON.parse(data);
            $element.removeClass("working");
            if(j_data.products.length) {
              var product = j_data.products[0];
              window.open("https://accounts.togetherhealth.co.uk/batch_reports/"+product.filename);
            } else {
              $container.append($("<h2 class='centered'>Batch reports</h2>"));
							$container.append($("<p class='centered'>There are no batch reports for that number. Your batch was likely to have been produced prior to our new searchable batch system being active. Please rest assured that your product was still tested and that future reports will be available.</p><p>&nbsp;</p>"));
            }
          });
        }

        __.preset_latest_batch = function() {
          var product_id = $('[name="product_id"]').val();
          if(product_id!="") {
            $("[data-product-action='show_latest_batch']").each(function(){
              var $element = $(this);
              $.get("https://accounts.togetherhealth.co.uk/batch/latest/?product_id="+product_id,function(data){
                var j_data = JSON.parse(data);
                if(j_data.products.length) {
                  var product = j_data.products[0];
                  $element.attr("href","https://accounts.togetherhealth.co.uk/batch_reports/"+product.filename).attr("target","_blank").removeAttr("data-product-action");
                }
              });
            });
          } else {
          }
        }
        
        __.show_latest_batch = function($element) {
          var product_id = $('[name="product_id"]').val();
          var $container = $("#batch_output");
          if(product_id!="") {
            $container.html("");
            $element.addClass("working");
            $.get("https://accounts.togetherhealth.co.uk/batch/latest/?product_id="+product_id,function(data){
              var j_data = JSON.parse(data);
              $element.removeClass("working");
              if(j_data.products.length) {
                var product = j_data.products[0];
                window.open("https://accounts.togetherhealth.co.uk/batch_reports/"+product.filename);

              } else {
                $container.append($("<h2 class='centered'>Batch reports</h2>"));
				$container.append($("<p class='centered'>There are no batch reports for that number. Your batch was likely to have been produced prior to our new searchable batch system being active. Please rest assured that your product was still tested and that future reports will be available.</p><p>&nbsp;</p>"));
              }
            });
          }
        }
        __.show_batch_form = function($element) {
          var $wrapper = $element.closest(".twinset");
          $wrapper.find(".twinset--search-form").slideDown();
          $wrapper.find(".twinset-broad-buttons").slideUp();
        }
        __.hide_batch_form = function($element) {
          var $wrapper = $element.closest(".twinset");
          $wrapper.find(".twinset--search-form").slideUp();
          $wrapper.find(".twinset-broad-buttons").slideDown();
        }
        __.find_batch = function($element) {
          var batch_no = $('[name="batch_no"]').val();
          var $container = $("#batch_output");
          if(batch_no!="") {
            $container.html("");
            $("#findbatch").addClass("working");
            $.get("https://accounts.togetherhealth.co.uk/batch/search/?batch_no="+batch_no,function(data){
              var j_data = JSON.parse(data);
              $("#findbatch").removeClass("working");
              if(j_data.products.length) {
                var $results_table = $("<table class='batch_reports' />");
                $results_table.append($("<tr><th>Product</th><th>Batch no</th><th></th></tr>"));
                for(i=0;i<j_data.products.length;i++) {
                  var product = j_data.products[i];
                  var $row = $("<tr />");
                  $row.append($("<td>"+product.title+"</td>"));
                  $row.append($("<td>"+product.batch_no+"</td>"));
                  $row.append($("<td><a href='https://accounts.togetherhealth.co.uk/batch_reports/"+product.filename+"' target='_blank' class='btn'>View report</a></td>"));
                  $results_table.append($row);
                }
                $container.append($("<h2 class='centered'>Batch reports</h2>"));
                $container.append($results_table);
              } else {
                $container.append($("<h2 class='centered'>Batch reports</h2>"));
				$container.append($("<p class='centered'>There are no batch reports for that number. Your batch was likely to have been produced prior to our new searchable batch system being active. Please rest assured that your product was still tested and that future reports will be available.</p><p>&nbsp;</p>"));
              }
            });
          }
        }
        __.scroll_master = function($element) {
          $(".mobile-gallery--picker .active").removeClass("active");
          $element.addClass("active");
          $(".mobile-gallery--master").scrollLeft(($element.data("image")-1)*$(".mobile-gallery--master").width());
          if($(window).width()>640) __.show_image_gallery($element);
        }
        __.gallery_start = function($element) {
          _.gallery.init($element.attr("data-image"),$element);
        }
        __.gallery_end = function($element) {
          _.gallery.destroy();
        }
        __.gallery_shift = function($element) {
          _.gallery.change($element);
        }
        __.gallery_prev = function($element) {
          _.gallery.prev($element);
        }
        __.gallery_next = function($element) {
          _.gallery.next($element);
        }
        __.gallery_block = function($element) {
          //Blocker to prevent close
        }
        __.gallery_show_image = function($element) {
          window.location.href = $element.find("img").attr("src");
        }
      }
      _.gallery = new function() {
        var __ = this;
        __.img_url = function($image) {
          var srcset = $image.attr("data-srcset");
          if(srcset==""||srcset==undefined) srcset = $image.attr("srcset");
          var urls = srcset.split(" ");
          return urls[urls.length-2].replace("_2048x","");

        }
        __.init = function(index = 1,$element) {
          if($element.data("image")!="") index = $element.data("image");
          var $source = $element.closest(".product-images--mobile");
          var $gallery = $("<div class='gallery-lightbox--screen' data-product-action='gallery_end'><div class='gallery-lightbox--frame' data-product-action='gallery_block' /></div>");
          var $image = $("<div class='gallery-lightbox--main-image' data-product-action='gallery_show_image' />");
          if(index==1) $image.append($("<img src='"+__.img_url($(".mobile-gallery--thumbnail:not(.mobile-only)").eq(0).find("img"))+"'>"));
          var $thumbs = $("<div class='gallery-lightbox--thumbnails' />");
          $source.find(".mobile-gallery--thumbnail img").each(function(){
            var $thumb = $("<div class='gallery-lightbox--thumbnail"+(index==$(this).closest("[data-image]").data("image")?" active":"")+"' />").append($("<img src='"+__.img_url($(this)).replace(".jpg","_100x.jpg")+"' data-src='"+__.img_url($(this))+"' data-product-action='gallery_shift'>"));
            $thumbs.append($thumb);
            if(index==$(this).closest("[data-image]").data("image")) $image.append($("<img src='"+__.img_url($(this))+"'>"));
          });
          var $buttons = $("<div class='gallery-lightbox--button gallery-lightbox--button--prev' data-product-action='gallery_prev'><svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 40 40' width='40' height='40'><path d='m15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z'></path></svg></div><div class='gallery-lightbox--button gallery-lightbox--button--next' data-product-action='gallery_next'><svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 40 40' width='40' height='40'><path d='m15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z'></path></svg></div>");
          var $close = $("<a href='#' class='account-page--window-screen-close' data-product-action='gallery_end'></a>");
          $gallery.find(".gallery-lightbox--frame").append($image).append($thumbs).append($buttons).append($close);
          $('body').append($gallery);
          $(".gallery-lightbox--main-image img").on("load",function(){_.gallery.change_ready()});
          __.refresh();
        }
        __.destroy = function() {
          $(".gallery-lightbox--screen").remove();
        }
        __.refresh = function() {
          if($(".gallery-lightbox--thumbnail.active").next().length>0) {
            $(".gallery-lightbox--button--next").show();
          } else {
            $(".gallery-lightbox--button--next").hide();
          }
          if($(".gallery-lightbox--thumbnail.active").prev().length>0) {
            $(".gallery-lightbox--button--prev").show();
          } else {
            $(".gallery-lightbox--button--prev").hide();
          }
        }
        __.change = function($element) {
          $(".gallery-lightbox--thumbnail").removeClass("active");
          $element.closest(".gallery-lightbox--thumbnail").addClass("active");
          $(".gallery-lightbox--main-image img").fadeOut(100,function(){
            $(".gallery-lightbox--main-image img").attr("src",$element.attr("data-src"));
          });
          __.refresh();
        }
        __.change_ready = function() {
          $(".gallery-lightbox--main-image img").fadeIn(100);
        }
        __.next = function($element) {
          if($(".gallery-lightbox--thumbnail.active").next().length>0) {
            __.change($(".gallery-lightbox--thumbnail.active").next().find("img"));
          }
          __.refresh();
        }
        __.prev = function($element) {
          if($(".gallery-lightbox--thumbnail.active").prev().length>0) {
            __.change($(".gallery-lightbox--thumbnail.active").prev().find("img"));
          }
          __.refresh();
        }
      }
      
      
	  //System level operations
	  _.acknowledge = function(message) {
	  }
	}

	$(function(){ main.productPage.init(); });

})(main.jQuery);






async function startRewards($element) {
  $element.css({"display":"block"});
  setTimeout(function(){
    new Splide($element[0], {
      autoplay: false,
      type: 'loop',
      perPage: 1,
      drag: true,
      arrows: true,
      pagination: true,
      breakpoints: {767:{arrows:false}}
    }).mount();
  },5);
    //Check back later
}


$(function(){
  
  $('body').on('click','.lion-no-activities-help .lion-action-button',function(e){
    window.location.href = "/pages/together-rewards";
    return false;
  }).on('click','#search-bar',function(e){
    $element = $(e.currentTarget);
    $element.find('[name="q"]').focus();
    return false;
  }).on('click','#search-bar .btn',function(e){
    e.stopPropagation();
  }).on('submit','form.submit-cart',function(e){
    if(!$('#checkout-agree #agree').is(':checked')) {
      $('#required-message p').slideDown();
      return false;
    }
  }).on('change','#agree',function(){
    if($(this).is(':checked')) {
      $('#required-message p').slideUp();
    }
  }).on('click','[data-info]',function(){
    return false;
  }).on('click','input.checkout,[name="checkout"]',function(){
    //Wipe stored accounts data
    delete sessionStorage.account_data;
  }).on("mouseenter mousedown touchstart",".main-nav .links li",function(){
    if($(this).find("script").length>0){
      var $contents = $($(this).find("script").text());
      $(this).find("script").remove();
      $(this).find(".main-submenu").append($contents);
    }
  });

  
    $('[href="#contact"]').on('click',function(e){
      Intercom('show');
      return false;
    });
    if(window.location.href.indexOf("?")>-1) {
      if(window.location.href.split("?")[1].indexOf("intercom")>-1) {
        setTimeout(getIntercom,100);
      }
    } else if(window.location.href.indexOf("#")>-1) {
      if(window.location.href.split("#")[1].indexOf("intercom")>-1) {
        setTimeout(getIntercom,100);
      }
    }
    function getIntercom() {
      try {
        Intercom('show');
      } catch {
        setTimeout(getIntercom,100);
      }
    }
  
    $('body').on('click','.collection-sidebar a',function(e){
      $element = $(e.currentTarget);
      $('.collection-wrapper').addClass('collection-refresh');
      $.get($element.attr('href'),function(data){
        $data = $(data);
        $('body').find('.collection-wrapper').html($data.find('.collection-wrapper').html());
        $('body').find('.collection-header').html($data.find('.collection-header').html());
        $('.collection-wrapper').removeClass('collection-refresh');
        window.history.pushState("", "Together Health - Supplements", $element.attr('href'));
        $('body').find('.collection-wrapper').find(".trustpilot-widget").each(function(){
          window.Trustpilot.loadFromElement($(this)[0]);
        });
        $("html,body").animate({scrollTop:$(".collection-wrapper").offset().top+2},250);
      });
      return false;
    });
  
  
  

  



  $('body').on('click','.collection-browser--menu a',function(e) {
    $element = $(e.currentTarget);
    $('.collection-browser--menu .active').removeClass('active');
    $element.addClass('active');
    var $browser = $element.closest('.featured-collection-browser').find('.featured-collection--products');
    $browser.css({'opacity':'0.4'});
    $.get($element.attr('href')+"?view=raw",function(data) {
      $browser.html(data);
      $browser.css({'opacity':'1'});
      
      $browser.find(".trustpilot-widget").each(function(){
        window.Trustpilot.loadFromElement($(this)[0]);
      });
    });
    return false;
  }).on('click','[href="/search"]',function(e){
    $('body').toggleClass('search-open');
    if($('body').hasClass('search-open')) setTimeout(function(){$("#search-bar input").first().focus();},100);
    return false;
  }).on('click','.product-tab',function(e){
    var $element = $(e.currentTarget);
    selectProductOption($element);
  }).on('click','[data-toggle-next] a',function(){
    $(this).closest('[data-toggle-next]').next().slideToggle();
    $(this).closest('[data-toggle-next]').toggleClass('active');
    return false;
  }).on('click','[href^="#"]:not([href="#"])',function(e){
    var $element = $(e.currentTarget);
    var $target = $($(e.currentTarget).attr('href'));
    $("body,html").animate({scrollTop:($target.offset().top - 100)});
    if($element.attr("href")=="#full-ingredients") {
      if(!$("#full-ingredients .ingredients--wrapper").is(":visible")) {
        $("#full-ingredients .ingredients--title").trigger("click");
      }
    }
  }).on('click',function(){
    $('body').removeClass('search-open');
    $("#search-results").hide();
  }).on('click','.has-submenu',function(e){
    if($(this).is(":hover")) { 
       $("body").focus();
    }
    if(window.innerWidth<500) return false;
  }).on('click','[data-toggle-collection-filter]',function(){
    if(!$(".collection_page--sidebar").hasClass("show-collection-filter")) {
      $("html,body").animate({scrollTop:$(".collection_page--sidebar").offset().top+2},250);
    }
    $(".collection_page--sidebar").toggleClass("show-collection-filter");
    return false;
  });
 
  $('.main-submenu').each(function(){
    $(this).closest('li').find('a').eq(0).addClass('has-submenu');
  });
  
  function selectProductOption($element) {
    var $form = $element.closest(".product-form--wrapper");
    $form.find(".product-form--option").hide();
    $form.find("#option-"+$element.data("option")).show();
    $form.find(".product-tabs .active").removeClass("active");
    $element.addClass("active");
    $form.find(".product-tabs").find('[type="radio"]').prop('checked',false);
    $element.find('[type="radio"]').prop('checked',true);
  }
  
  setTimeout(function(){
    $(".product-navigation [data-link-title]").each(function(){
      var linkTitle = $(this).data("link-title").trim().toLowerCase();
      var $section = undefined;
      $("section .container--width,.shopify-section .container--width").find("h2,h3:not(.ingredients-carousel__item-title,.section-intro__title)").each(function(){
        if($(this).text().trim().toLowerCase().indexOf(linkTitle)>-1&&$(this).text().trim().toLowerCase().indexOf("ancient")<0) {
          if(!$section) $section = $(this).closest('section,.shopify-section');
        }
      });
      if(!$section&&$(this).is("[data-link-title-alt]")) {
        var linkTitleAlt = $(this).attr("data-link-title-alt").trim().toLowerCase();
        $("section .container--width,.shopify-section").find("h2,h3:not(.ingredients-carousel__item-title,.section-intro__title)").each(function(){
          if($(this).text().trim().toLowerCase().indexOf(linkTitleAlt)>-1&&$(this).text().trim().toLowerCase().indexOf("ancient")<0) {
            if(!$section) $section = $(this).closest('section,.shopify-section');
          }
        });
      }
      if(!$section&&$(this).is("[data-link-title-alt-partial]")) {
        var linkTitleAltPartial = $(this).attr("data-link-title-alt-partial").trim().toLowerCase();
        $("section .container--width,.shopify-section .container--width").find("h2,h3:not(.ingredients-carousel__item-title,.section-intro__title)").each(function(){
          if($(this).text().trim().toLowerCase().indexOf(linkTitleAltPartial)>-1&&$(this).text().trim().toLowerCase().indexOf("ancient")<0) {
            if(!$section) $section = $(this).closest('section,.shopify-section');
          }
        });
      }
      if($section) {
        var handle = $(this).data("link-title").toLowerCase().replace(/ /g,"-");
        if($section.attr("id")!="full-ingredients") {
          $section.attr("id",handle);
          $(this).find('a').prop('href','#'+handle);
        }
      }
    });
    //Move .product-navigation outside of new sectioned wrapper
    $(".product-navigation--dock").closest(".shopify-section").after($(".product-navigation--dock"));
    var btt = false;
    var $btt_link = $($("#product_back_to_top").html());
    var $mobile_btt_link = $($("#product_back_to_top_mobile").html());
    var btt_counted = 0;
    if($(window).width()>0) { //Changed from 480 so the links are always added - visibility is now simply suppressed on mobile
      $(".template-product #min-range .shopify-section section").each(function(){
        var title = $(this).find("h2,h3").text().toLowerCase();
        
        if(btt) {
          var $wrapper = $(this).find(".container--width").eq(0);
          var $wrapper = $(this);
          $wrapper.append($btt_link.clone());
        }
        
        if(title.indexOf("much more")>-1) {
          //Trigger is AFTER
          btt = true;
        }

        btt_counted++;

        if(btt_counted==$(".template-product #min-range .shopify-section section").length) {
          var $wrapper = $(this).find(".container--width").eq(0);
          var $wrapper = $(this);
          $wrapper.append($mobile_btt_link.clone());
        }
  
      });
    }
    
  },2000);


  $('.twinset:not(.has-icon-image) .twin-image .image-wrapper img').on('load',function(){
    $(this).closest('.image-wrapper').addClass('animate');
  });


  $('.drip-form').on('submit',function(e) {

    $(this).find('#email').attr('name','fields[email]').attr('id','drip-email');

      $(this).find('[type="submit"]').hide();
      $(this).find('.drip-working').show();

      if($(this).parent().attr('id')=="drip-blog-signup") { $(this).find('.drip-working').css({'display':'inline-block'}); }

      var form = $(this);
      var url = form.attr('action');
      var $source = $(this);

      $.ajax({
        type: "POST",
        url: url,
        data: form.serialize(), // serializes the form's elements.
        success: function(data) {
          $source.next('.drip-confirmation').show();
          $source.hide();
          $source.closest("#sidebarPop").addClass('success');
          $source.closest("#product-page-popup").addClass('success');
        },
        error: function(data) {
          $source.next('.drip-confirmation').show();
          $source.hide();
          $source.closest("#sidebarPop").addClass('success');
          $source.closest("#product-page-popup").addClass('success');
        }
      });

      if($(this).data('has-additional')!="") {
        var url = $(this).data('has-additional');
        var jqxhr = $.ajax({
          url: url,
          method: "GET",
          dataType: "json",
          data: $(this).serializeObject()
        }).success(
          // no action required in any outcome
        );
      }
    
    //Suppress product page popup
    setCookie("ppPopup","1",90);
    
    e.preventDefault();
    return false;
  });
  
  //Product page FAQs
  $('.section-product-faqs .faqs-wrapper').each(function(){
    var source = $(this).data('intercom-source');
    var title = $(this).data('category-heading');
    if(source&&source!="") {
      var $wrapper = $(this);
      $.get("https://accounts.togetherhealth.co.uk/getFAQs/"+source+"/",function(data){
        var faqs = JSON.parse(data).faqs;
        if(faqs.length>0) {
          if(title!="") {
            var $faq_title = $("<p style='text-align:center;text-transform:uppercase;margin-top:4em;'>"+title+"</p>");
          } else {
            var $faq_title = $("<h3><b>FAQs</b></h3>");
          }
          var $faq_wrapper = $("<div class='product-faqs' />");
          for(f=0;f<faqs.length;f++) {
            faq = faqs[f];
            var $article_title = $("<p class='faq' data-toggle-next><a href='#'>"+faq.title+"</a></p>");
            var $article_textbox = $("<textarea>"+faq.body+"</textarea>");
            if($article_textbox.val()!="") {
              var $article_body = $("<div class='faq_inner hidden'>"+$article_textbox.val()+"</div>");
              var $article_wrapper = $("<div class='faq--outer-wrapper' />");
              $article_wrapper.append($article_title).append($article_body);
              $faq_wrapper.append($article_wrapper);
            }
          }
          $wrapper.append($faq_title).append($faq_wrapper);
        }
      });
    } else {
      $(this).closest(".section-product-faqs").hide();
    }
  });
  
  
    const tv = 1;
    $('#product-page-popup').css({"bottom":"-"+$(this).height(),"top":"auto"});
      if(getCookie("ppPopup")!="1"&&!$('body').hasClass('customer-logged-in')) {
        if(getCookie("ppPopup")=="2") {
          $('#product-page-popup').addClass("minimised");
          $('#product-page-popup').find(".container p,#drip-footer-signup").hide();
          setTimeout(function(){if($("#product-page-popup .klaviyo-form").length>0){$('#product-page-popup').animate({"bottom":"-1px"},1000);}},15000);
        } else {
          if($(window).width()<541){
            setTimeout(function(){if($("#product-page-popup .klaviyo-form").length>0){$('#product-page-popup').animate({"bottom":"20px"},1000);}},15000);
          } else {
            setTimeout(function(){if($("#product-page-popup .klaviyo-form").length>0){$('#product-page-popup').animate({"bottom":"80px"},1000);}},15000);
          }
        }
      }
      $('#product-page-popup').on('click','.klaviyo-form button',function(){
        setCookie("ppPopup","1",90);
      });
      $('#product-page-popup').on('click touchstart','[data-action]',function(){
        if($(this).attr('data-action')=='close-popup') {
          if(getCookie("ppPopup")=="2") {
            setCookie("ppPopup","0",90);
            $('#product-page-popup').removeClass("minimised");
            $('#product-page-popup').find(".container p,#drip-footer-signup").slideDown(150);
            $('#product-page-popup').animate({"bottom":"80px"},250);
          } else {
            setCookie("ppPopup","2",90);
            $('#product-page-popup').addClass("minimised");
            $('#product-page-popup').find(".container p,#drip-footer-signup").slideUp(150);
            $('#product-page-popup').animate({"bottom":"-1px"},150);
          }
          return false;
        } else if($(this).attr('data-action')=='maximise-popup') {
          setCookie("ppPopup","0",90);
          $('#product-page-popup').removeClass("minimised");
          $('#product-page-popup').find(".container p,#drip-footer-signup").slideDown(150);
          $('#product-page-popup').animate({"bottom":"80px"},150);
          return false;
        } else if($(this).attr('data-action')=='actual-close-popup') {
          setCookie("ppPopup","1",90);
          $('#product-page-popup').animate({"bottom":"-"+$('#product-page-popup').height()+20},250);
          return false;
        } else if($(this).attr('data-action')=='no-thanks') {
          setCookie("ppPopup","1",90);
          $('#product-page-popup').animate({"bottom":"-"+$('#product-page-popup').height()+20},250);
          return false;
        } else if($(this).attr('data-action')=='sure') {
          $('#product-page-popup [data-ab-id="phase1"]').slideUp();
          $('#product-page-popup [data-ab-id="phase2"]').slideDown();
          return false;
        } else if($(this).attr('data-action')=='convert') {
          setCookie("ppPopup","1",90);
          return false;
        }
      });
      $('#product-page-popup h2 span').on('click',function(){
        const el = document.createElement('textarea');
        el.value = "T4L10";
        el.setAttribute('readonly', '');
        el.style.position = 'absolute';
        el.style.left = '-9999px';
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);
        $(this).addClass('copied');
      });
  
    $("[data-navigation-function]").on('click',function(){
      var operation = $(this).data('navigation-function');
      var $carousel = $(this).closest('.question-slide-carousel');
      var $slide = $(this).closest('.question-slide');
      if(operation=="next") {
        $carousel.animate({'left':-(($slide.index()+1)*100)+"%"});
      } else if(operation=="back") {
        $carousel.animate({'left':-(($slide.index()-1)*100)+"%"});
      } else if(operation=="submit") {
        var first_error_slide = $('.required~.required-message, .error~.error-message').eq(0).closest('.question-slide').index();
        if(first_error_slide<0) first_error_slide = 0;
        $carousel.animate({'left':-(first_error_slide*100)+"%"});
      }
      if(operation!="submit") {
        $('html,body').animate({'scrollTop':$('#top-of-form').offset().top});
        return false;
      }
    });

	//Product form pre-order
    $('body').on('submit','[data-pre-order="true"] form',function(e){
      e.preventDefault();
      return false;
    });
    $('[data-pre-order="true"] form').removeAttr('method action');

	$("[data-pre-order='true'] .product-form--wrapper form").eq(1).find("button").text("Pre-order");
	if($(".gPreorderCountdownWrapper").length>0) {
      $('body').on('click','.product-form--option button.btn:not(.allow)',function(){
        var $sourceForm = $('.shopify-product-form').eq(1);
        var $newForm = $sourceForm.clone();
        $newForm.attr("method","post").attr("action","/cart/add");
        $newForm.find('*').remove();
        $sourceForm.find('.has-quantity,input').each(function(){
          $newForm.append($(this).clone());
        });
        var $newField = $("<input type='hidden' name='properties[pre-order]' value='true'>");
        $newForm.append($newField);
        $newForm.find('button').addClass('allow btn').text("Proceed").after($("<a href='#' id='endPreOrder'>Cancel</a>"));
        $newForm.find('button').attr('type','submit');
        var days = $('.flip-clock-group:nth-child(1) .active .top').text();
        $('#hasDays').text($('#hasDays').text().replace("[%days%]",days));
        $('#preOrderModal .modal_window').append($newForm);
        $('#preOrderModal').css({'display':'flex'});
        return false;
      });
      $('body').on('click','#endPreOrder',function(){
        window.location.reload();
        return false;
      });
    }
    
    
  setTimeout(function(){
    if(getCookie("accepts_cookies")!="1") $('body').addClass('show-cookie-message');
  },4000);
  $('body').on('click','.cookie-wrapper .cookie_ok',function(e){
    $('body').removeClass('show-cookie-message');
    setCookie("accepts_cookies","1",90);
    return false;
  });

	$(".title-block--mode--slide").slideDown();




});






  function preorderResponse(data) {
        var j_data = JSON.parse(data);

        if(j_data.preorder==true) {

          if(j_data.block_all_sales==true) {
            //Full block
            $(".product-form--option form").replaceWith($("<div><p>This product is currently out of stock</p></div>"));
            $(".product-tabs [data-option=one-time]").trigger("click");

          } else {
            //Standard pre-order

            //Remove subscription option
            $(".section-product-block,.product-form--wrapper").attr("data-pre-order","true");
            $(".product-tab[data-option='subscription']").removeClass("active");
            $(".product-tab[data-option='one-time']").addClass("active");
            $("#option-subscription").removeClass("selected").addClass("hidden").hide();
            $("#option-subscription > form > div").html("<p>This product is not available for pre-order on subscription</p>");
            $("#option-one-time").removeClass("hidden").addClass("selected").show();
            $("#option-one-time .btn").attr("type","button");
            $("[data-option='one-time'] [name='id']").prop("checked",true);
            
            var date1 = new Date(j_data.restock_date); var date2 = new Date();
            var difference = date1. getTime() - date2. getTime();
            var days = Math. ceil(difference/(1000*3600*24));
            if(days>0) {
              $("#option-one-time .shopify-product-form").append("<p class='preorder_due'>Due back in stock in "+days+" day"+(days>1?"s":"")+"</p>");
            } else if(days==0) {
              $("#option-one-time .shopify-product-form").append("<p class='preorder_due'>Due back in stock today!</p>");
            } else {
              $("#option-one-time .shopify-product-form").append("<p class='preorder_due'>Due back in stock soon!</p>");
            }

            $('body').on('click','.product-form--option button.btn:not(.allow)',function(){

              var $sourceForm = $('.shopify-product-form').eq(1);
              var $newForm = $sourceForm.clone();
              $newForm.attr("method","post").attr("action","/cart/add");
              $newForm.find('*').remove();
              $sourceForm.find('.select-style:has([name="quantity"]),input,button').each(function(){
                $newForm.append($(this).clone());
              });
              var $newField = $("<input type='hidden' name='properties[pre-order]' value='true'>");
              $newForm.append($newField);
              $newForm.find('button').addClass('allow btn').text("Proceed").after($("<a href='#' id='endPreOrder'>Cancel</a>"));
              $newForm.find('button').attr('type','submit');
              if(days>-1) {
                $('#hasDays').text($('#hasDays').text().replace("[%days%]",days));
              } else {
                var content = $('#hasDays').text().split(".");
              $('#hasDays').html(content[0]+". We are hoping to ship this soon. Please <a href='#'>contact support</a> for a more accurate expected shipping date.");
              }
              $('#preOrderModal .modal_window').append($newForm);
              $('#preOrderModal').css({'display':'flex'});
              return false;
            });
            $('body').on('click','#endPreOrder',function(){
              $('#preOrderModal .modal_window form').remove();
              $('#preOrderModal').css({'display':'none'});
              return false;
            });
            //End of standard pre-order
          }

        } else {
        }  
  }

  $(function(){
    $("[data-namespace='feb18']").on('click','.tab_area h3',function(e){
      
      $(this).closest('h3').toggleClass('active');
      $(this).closest('h3').next('div').slideToggle();
      
      e.preventDefault();
      return false;
    });
    //Toggle FAQs
    $("[data-namespace='feb18']").on('click','.tab_area .faq a',function(e){
      if($(this).closest('h4').hasClass('active')) {
        $("[data-namespace='feb18'] .tab_area .faq a").closest(".faq").removeClass('active');
        $("[data-namespace='feb18'] .tab_area .faqa").slideUp(150);
      } else {
        $("[data-namespace='feb18'] .tab_area .faq a").closest(".faq").removeClass('active');
        $("[data-namespace='feb18'] .tab_area .faqa").slideUp(150);
        $(this).closest(".faq").addClass('active');
        $(this).closest('h4').next('div').slideDown(150);
      }
      e.preventDefault();
      return false;
    });
    //Pre-orders
    if(meta&&meta.hasOwnProperty("product")) {
      if(meta_product&&meta_product.hasOwnProperty("products")&&meta_product.products.length>0) {
        var t_data = {constituent_products:meta_product.products.join(",")};
        $.post("https://accounts.togetherhealth.co.uk/preorders/getpreorderbundle/?v="+(Math.round(Math.random()*10000000)),t_data,function(data){
          preorderResponse(data);
        });
      } else {
        $.get("https://accounts.togetherhealth.co.uk/preorders/"+meta.product.id+"/getpreorder/?v="+(Math.round(Math.random()*10000000)),function(data){
          preorderResponse(data);
        });
      }
    }

    $("#page-search").on("keyup",function(){
      if(typeof(page_search)!=="undefined") clearTimeout(page_search);
      page_search = setTimeout(function(){pageSearch()},100);
    });

    if(window.sitra) {
      window.sitra.service.log("load");
    }
    
  });

  var page_search = undefined;
  function pageSearch() {
    var term = $("#page-search").val().toLowerCase().replace(/[^a-z0-9]/gi,'');
    var matches = 0;
    $(".featured-ingredient").show();
    if(term.length>1) {
      $(".featured-ingredient").each(function(){
        if($(this).text().toLowerCase().replace(/[^a-z0-9]/gi,'').indexOf(term)>-1) {
          matches++;
        } else {
          $(this).hide();
        }
      });
    }
  }


  function mfmoney(input) {
    return "£"+(input/100).toFixed(2);
  }

  $(function(){
    var qs = window.location.href.split("?");
    if(qs.length>1){
      if(qs[1].indexOf("activate")>-1) {
        main.afterFlex.page_action.show_activation_popup();
      }
    }
    if(typeof(load_nc)!="undefined"&&load_nc){
      $script = $("<script src='"+nc_path+"' defer />");
      $('head').append($script);
    }
    if(typeof(load_pp)!="undefined"&&load_pp){
      $script = $("<script src='"+pp_path+"' defer />");
      $('head').append($script);
    }
    if(typeof(load_mc)!="undefined"&&load_mc){
      $script = $("<script src='"+mc_path+"' defer />");
      $('head').append($script);
    }

    const params = new Proxy(new URLSearchParams(window.location.search), {
      get: (searchParams, prop) => searchParams.get(prop),
    });
    if(params.link!=""&&$("#terms-amp-conditions").length>0) {
      setTimeout(function(){
        var section = params.link.replace("_"," ").toLowerCase();
        $("#min-range .container--width b").each(function(){
          var content = $(this).text().toLowerCase();
          if(content.indexOf(section)===0) {
            $("html,body").scrollTop($(this).offset().top-100);
          }
        });
      },500);
    }

    $("#search-bar [name='q']").on("keyup change",function(e){
      $("#search-results").show();
      var search_term = $(this).val().toLowerCase();
      var results_limit = 3;
      var results_given = 0;
      $("#search-results .search-results--result").hide();
      $("#search-results .search-results--result").each(function(){
        $(this).attr("data-search-score",utilities.similarity(search_term,$(this).find("h5").text().toLowerCase()));
        if($(this).text().toLowerCase().indexOf(search_term)>-1||$(this).attr("data-search-score")>0.35) {
          $(this).show();
        }
      });
      //Sort results
      var $wrapper = $('#search-results .search-results--grid');
      $wrapper.find('.search-results--result').sort(function(a, b) {
        return +b.getAttribute('data-search-score') - +a.getAttribute('data-search-score');
      }).appendTo($wrapper);
      $("#search-results .search-results--result").each(function(){
        if(results_given<results_limit) {
          results_given++;
        } else {
          $(this).hide();
        }
      });
      if($("#search-results .search-results--result:visible").length==0) $("#search-results").hide();
      
      return false;
    });

    
    
  });

